// Magyar szövegek az Outfino Partner Portálhoz.
const hu = {
  // ---- Eseménynaptár (community challenge calendar) ----
  'eventCalendar.title': "Eseménynaptár",
  'eventCalendar.lead': "Az Outfino napi közösségi kihívásai: a cél, az időpont, a haladás és minden márka felajánlott jutalma. A saját partnernapjaidat és jutalmaidat kiemelve látod.",
  'eventCalendar.prevMonth': "Előző hónap",
  'eventCalendar.nextMonth': "Következő hónap",
  'eventCalendar.today': "Ma",
  'eventCalendar.todayMarker': "Ma",
  'eventCalendar.planningWindow': "Előre tervezve: {from} – {to}",
  'eventCalendar.loadError': "Nem sikerült betölteni a naptárat. Próbáld újra.",
  'eventCalendar.empty': "Még nincsenek kihívások",
  'eventCalendar.emptyHint': "Itt jelennek meg a közösségi kihívások — mindig a következő 30 napra tervezve.",
  'eventCalendar.status.scheduled': "Ütemezve",
  'eventCalendar.status.live': "Folyamatban",
  'eventCalendar.status.completed': "Teljesítve",
  'eventCalendar.status.failed': "Nem teljesült",
  'eventCalendar.status.draft': "Tervezet",
  'eventCalendar.tier.normal': "Normál nap",
  'eventCalendar.tier.challenge': "Kihívásnap",
  'eventCalendar.tier.special': "Különleges esemény",
  'eventCalendar.mayChange': "Tervezett, változhat",
  'eventCalendar.ownLegend': "A márkádhoz kapcsolódó",
  'eventCalendar.hasReward': "Van jutalom",
  'eventCalendar.yourPartnerDay': "A te partnernapod",
  'eventCalendar.yourReward': "A te jutalmad",
  'eventCalendar.mechanic.label': "Jutalmazás",
  'eventCalendar.mechanic.all_contributors': "Minden hozzájáruló kap",
  'eventCalendar.mechanic.raffle': "Sorsolás",
  'eventCalendar.mechanic.gift_drop': "Ajándékláda a galaxisban",
  'eventCalendar.mechanic.wheel_event': "Szerencsekerék",
  'eventCalendar.mechanic.none': "Jutalom nélkül",
  'eventCalendar.mechanic.short.all_contributors': "Mindenki",
  'eventCalendar.mechanic.short.raffle': "Sorsolás",
  'eventCalendar.mechanic.short.gift_drop': "Láda",
  'eventCalendar.mechanic.short.wheel_event': "Kerék",
  'eventCalendar.mechanic.terms.all_contributors': "A cél teljesülésekor minden hozzájáruló kap egyet (legfeljebb {n} fő).",
  'eventCalendar.mechanic.terms.raffle': "A cél teljesülésekor {n} nyereményt sorsolnak ki a hozzájárulók között.",
  'eventCalendar.mechanic.terms.gift_drop': "A cél teljesülésekor {n} ajándékláda érkezik a galaxisba a hozzájárulóknak.",
  'eventCalendar.mechanic.terms.gift_drop_anyone': "A cél teljesülésekor {n} ajándékláda érkezik a galaxisba — bárki elkaphatja, aki bent van.",
  'eventCalendar.mechanic.terms.wheel_event': "A cél teljesülésekor megnyílik a szerencsekerék; minden hozzájáruló pörgethet ({n} nyeremény).",
  'eventCalendar.mechanic.completed': "Teljesült — a jogosultak köre lezárult.",
  'eventCalendar.mechanic.completedEarly': "Már a nap vége előtt teljesült — a jogosultak köre lezárult, a később érkezők lemaradtak.",
  'eventCalendar.goal': "Cél",
  'eventCalendar.when': "Időpont",
  'eventCalendar.progressLabel': "Haladás",
  'eventCalendar.progress': "a cél {pct}%-a",
  'eventCalendar.partnerDay': "Partnernap",
  'eventCalendar.rewards': "Jutalmak",
  'eventCalendar.noRewards': "Jutalom nélküli kihívás.",
  'eventCalendar.rewardType.gift_rain': "Ajándékeső",
  'eventCalendar.rewardType.cart_coupon': "Kosárkupon",
  'eventCalendar.rewardType.wheel_spin': "Szerencsekerék",
  'eventCalendar.quantity': "{n} db",
  'eventCalendar.rewardStatus.planned': "tervezett",
  'eventCalendar.rewardStatus.reserved': "lefoglalva",
  'eventCalendar.rewardStatus.published': "meghirdetve",
  'eventCalendar.rewardStatus.released': "felszabadítva",
  'eventCalendar.rewardStatus.granted': "kiosztva",
  'eventCalendar.metric.ratings_count': "Outfit-értékelések",
  'eventCalendar.metric.ootd_entries': "OOTD-nevezések",
  'eventCalendar.metric.ootd_likes': "OOTD-like-ok",
  'eventCalendar.metric.wardrobe_items': "Új gardróbdarabok",
  'eventCalendar.metric.galaxy_moves': "Galaxis-aktivitás",
  'eventCalendar.metric.brand_visits': "Márkalátogatások",
  'eventCalendar.metric.product_views': "Termékmegtekintések",
  'eventCalendar.metric.product_likes': "Termék-like-ok",
  'eventCalendar.metric.invites_accepted': "Elfogadott meghívók",

  // ---- Prize Pool ----
  'eventCalendar.prizePoolLead': "A márkád jutalmat ajánlhat fel a közösségi kihívásokhoz.",
  'eventCalendar.prizePoolLink': "Prize Pool megnyitása",
  'prizePool.title': "Prize Pool",
  'prizePool.lead': "Itt ajánlhatsz fel kuponokat és ajándékládákat az Outfino napi közösségi kihívásaihoz, havi darabszám-kerettel. Hónapról hónapra látod, hányszor választották ki és hányszor osztották ki a jutalmadat.",
  'prizePool.prevMonth': "Előző hónap",
  'prizePool.nextMonth': "Következő hónap",
  'prizePool.new': "Új felajánlás",
  'prizePool.newTitle': "Új felajánlás",
  'prizePool.editTitle': "Felajánlás szerkesztése",
  'prizePool.create': "Felajánlás",
  'prizePool.save': "Mentés",
  'prizePool.cancel': "Mégse",
  'prizePool.edit': "Szerkesztés",
  'prizePool.withdraw': "Visszavonás",
  'prizePool.withdrawBlocked': "Nem vonható vissza, mert lefoglalták ezekre a napokra: {days}",
  'prizePool.withdrawConfirmTitle': "Visszavonod a felajánlást?",
  'prizePool.withdrawConfirmBody': "A(z) „{name}” felajánlás kikerül a Prize Poolból: a bot nem választhatja ki többé jutalomnak. Ez nem vonható vissza.",
  'prizePool.withdrawConfirmCancel': "Mégse",
  'prizePool.reservedEditNote': "Ezt a felajánlást már lefoglalták egy kihívásra: amit a lefoglalt jutalom ígér (típus, kedvezmény, termékek, összevonhatóság), az nem változhat. A megnevezés módosítható, a keretek csak növelhetők, az érvényesség csak meghosszabbítható.",
  'prizePool.empty': "Még nincs felajánlásod. A jutalmaid itt jelennek meg, havi statisztikával.",
  'prizePool.type.cart_coupon': "Kosárkupon",
  'prizePool.type.gift_rain': "Ajándékláda (termékek)",
  'prizePool.type.wheel_spin': "Szerencsekerék-nyeremény",
  'prizePool.status.offered': "Felajánlva",
  'prizePool.status.reserved': "Lefoglalva",
  'prizePool.status.withdrawn': "Visszavonva",
  'prizePool.status.expired': "Lejárt",
  'prizePool.combinableTag': "összevonható",
  'prizePool.rate': "{decided} eseményből {granted} alkalommal került kiosztásra",
  'prizePool.rateNone': "Ebben a hónapban még nem volt lezárt esemény",
  'prizePool.selected': "{n}× kiválasztva",
  'prizePool.notCompleted': "{n} nem teljesült",
  'prizePool.used': "{n} db kiosztva",
  'prizePool.held': "{n} db lefoglalva",
  'prizePool.remaining': "{n} db maradt a havi {cap} db-ból",
  'prizePool.noCap': "nincs havi keret",
  'prizePool.heldDays': "Lefoglalt napok",
  'prizePool.pcs': "db",
  'prizePool.field.title': "Megnevezés",
  'prizePool.field.type': "Típus",
  'prizePool.field.discountType': "Kedvezmény",
  'prizePool.field.percent': "Mérték (%)",
  'prizePool.field.amount': "Összeg",
  'prizePool.field.currency': "Pénznem",
  'prizePool.field.minCart': "Minimum kosárérték (beváltáshoz)",
  'prizePool.field.maxUses': "Max. felhasználás (összesen)",
  'prizePool.field.monthlyCap': "Havi keret (db)",
  'prizePool.field.validFrom': "Érvényes ettől",
  'prizePool.field.validUntil': "Érvényes eddig (lejárat)",
  'prizePool.field.combinable': "Összevonható a saját akcióimmal",
  'prizePool.field.products': "Termékek ({n} kiválasztva)",
  'prizePool.field.product_ids': "termékek",
  'prizePool.field.discount_value': "mérték",
  'prizePool.field.discount_type': "kedvezmény",
  'prizePool.field.min_cart_value': "minimum kosárérték",
  'prizePool.field.max_uses': "max. felhasználás",
  'prizePool.field.valid_until': "lejárat",
  'prizePool.productSearch': "Keresés a termékeid között…",
  'prizePool.noProducts': "Nincs találat.",
  'prizePool.discount.none': "— csak termék —",
  'prizePool.discount.percent': "Százalékos",
  'prizePool.discount.fixed': "Fix összeg",
  'prizePool.preview.title': "Maximális kedvezmény",
  'prizePool.preview.percent': "A kupon legfeljebb {max}% kedvezményt ad.",
  'prizePool.preview.percentStacked': "A saját {sale}%-os akcióddal összevonva legfeljebb {max}% (a {coupon}% a már leárazott árra jön).",
  'prizePool.preview.fixed': "{amount} kedvezmény, legalább {min} kosárértéktől — vagyis legfeljebb a kosárérték {share}%-a.",
  'prizePool.preview.combinable': "Összevonható a saját akcióiddal.",
  'prizePool.preview.notCombinable': "Nem vonható össze a saját akcióiddal (ez az alapbeállítás).",
  'prizePool.problem.products': "Válassz legalább egy terméket.",
  'prizePool.problem.discount': "Válaszd ki a kedvezmény típusát.",
  'prizePool.problem.value': "Adj meg érvényes mértéket.",
  'prizePool.problem.currency': "A fix összeghez pénznem kell (pl. HUF).",
  'prizePool.problem.minCart': "Fix összegnél a minimum kosárérték kötelező, és nagyobb a kedvezménynél.",
  'prizePool.problem.maxUses': "Fix összegnél a max. felhasználás kötelező (pozitív egész).",
  'prizePool.problem.validUntil': "Fix összegnél a lejárat kötelező.",
  'prizePool.problem.cap': "A havi keret pozitív egész szám.",
  'prizePool.problem.validity': "Az érvényesség vége nem lehet a kezdete előtt.",
  'prizePool.error.offer_reserved': "Nem lehetséges, mert lefoglalták ezekre a napokra: {days}",
  'prizePool.error.offer_version_conflict': "Közben módosult a felajánlás — frissítsd az oldalt.",
  'prizePool.error.offer_not_available': "Ez a felajánlás már nem aktív (visszavonva vagy lejárt).",
  'prizePool.error.offer_not_found': "A felajánlás nem található.",
  'prizePool.error.invalid_parameters': "Érvénytelen mező: {field}",
  'prizePool.error.INSUFFICIENT_PERMISSIONS': "Ehhez nincs jogosultságod (kampánykezelés).",
  'prizePool.error.generic': "Nem sikerült. Próbáld újra.",
  'prizePool.howTitle': "Hogyan működik az eseménybot?",
  'prizePool.how.day': "Az Outfino közössége naponta egy közös kihívást teljesít, 09:00 és 24:00 között (budapesti idő). Minden kihívás aktivitás-alapú: outfitértékelés, OOTD, galaxis- és márkafelfedezés, termékmegtekintés.",
  'prizePool.how.pool': "A kihívások jutalma kizárólag jóváhagyott készletből jön: a partnerek Prize Pool-felajánlásaiból és az Outfino saját keretéből. Az eseménybot nem talál ki új jutalmat, csak ebből válogat.",
  'prizePool.how.contributors': "Jutalmat csak az kaphat, aki aznap hozzájárult a kihívás teljesítéséhez.",
  'prizePool.how.noPurchase': "A kihívás és a nyeremény megszerzése soha nem függ vásárlástól. A kupon beváltásához természetesen vásárlás kell, a megszerzéséhez soha.",
  'prizePool.how.released': "Ha egy kihívás nem teljesül, a rá lefoglalt jutalmad felszabadul, és nem fogyasztja a havi keretedet.",
  'prizePool.how.partnerDays': "Havonta néhány partnernap egy-egy márka köré épül — ezeken is csak aktivitás-alapú a cél.",
  'prizePool.how.benefits': "A felajánlott jutalmad és a márkád megjelenik a 3D Style Universe kihívástábláján és az Eseménynaptárban; partnernapon a márkád áll a középpontban.",
  'prizePool.how.withdraw': "A még le nem foglalt felajánlásodat bármikor visszavonhatod: jutalmat csak a következő naptól kezdődő kihívásokra foglalunk. A lefoglalt és a meghirdetett jutalom már nem vonható vissza.",
  'prizePool.how.combinable': "A kuponod alapból nem vonható össze a saját akcióiddal; kupononként engedélyezheted, és itt látod a lehetséges maximális kedvezményt.",

  // ---- Nav ----
  'nav.what': 'Hogyan működik',
  'nav.why': 'Miért csatlakozz',
  'nav.dashboard': 'Vezérlőpult',
  'nav.login': 'Bejelentkezés',

  // ---- Hero ----
  'hero.badge': 'Outfino márkáknak',
  'hero.title': 'Tedd a márkádat személyre szabott vásárlási élménnyé',
  'hero.subtitle':
    'Az Outfino segít abban, hogy a ruháid ne egyszerűen minél több emberhez, hanem a megfelelő emberekhez jussanak el. AI rendszerünk felismeri a felhasználók egyedi stílusát, és azoknak ajánlja a termékeidet, akiknél valóban relevánsak.',
  'hero.ctaLogin': 'Bejelentkezés',
  'hero.ctaLearn': 'Tudj meg többet',

  // ---- What it does ----
  'what.eyebrow': 'Hogyan működik',
  'what.title': 'Érd el azokat, akiknek valóban tetszeni fognak a termékeid',
  'what.body':
    'Így nemcsak nagyobb láthatóságot kapsz, hanem magasabb vásárlási szándékkal rendelkező közönséget is. A személyre szabott ajánlás relevánsabb vásárlási élményt és jobb minőségű forgalmat hoz az áruházadnak.',

  // ---- Why partner ----
  'why.eyebrow': 'Miért érdemes partnerként csatlakozni?',
  'why.title': 'Magasabb vásárlási szándékú közönség, nem csak több kattintás',
  'why.audience.title': 'A megfelelő vásárlókat éred el',
  'why.audience.body':
    'Termékeid azoknak jelennek meg, akiknek valóban illenek a stílusához.',
  'why.intent.title': 'Magasabb konverzió',
  'why.intent.body': 'A személyre szabott ajánlások jobb eredményeket hoznak.',
  'why.visibility.title': 'Nagyobb láthatóság',
  'why.visibility.body':
    'Megjelensz az AI ajánlásaiban, outfit elemzésekben és stílusfelfedezés során.',
  'why.insights.title': 'Részletes statisztikák',
  'why.insights.body':
    'Kövesd a kattintásokat, megtekintéseket és a teljesítményt.',
  'why.integration.title': 'Egyszerű integráció',
  'why.integration.body':
    'Csatlakoztasd Shopify áruházadat, a termékek automatikusan szinkronizálódnak.',

  // ---- Your Brand Dashboard ----
  'dash.eyebrow': 'Brand Dashboard',
  'dash.title': 'Kezeld a márkádat egy helyen',
  'dash.subtitle': 'Minden, amire szükséged van, hogy növekedj az Outfinóval.',
  'dash.profile.title': 'Márkaprofil kezelése',
  'dash.profile.body': 'Tartsd naprakészen a márkaneved, leírásod és logód.',
  'dash.sync.title': 'Termékkatalógus szinkronizálása',
  'dash.sync.body':
    'Csatlakoztasd a Shopify-t, és a katalógusod automatikusan szinkronban marad.',
  'dash.track.title': 'Statisztikák és analitikák',
  'dash.track.body': 'Kövesd a kattintásokat, megtekintéseket és konverziókat.',
  'dash.campaigns.title': 'Exkluzív kampányok létrehozása',
  'dash.campaigns.body': 'Indíts exkluzív ajánlatokat a hozzád illő közönségnek.',
  'dash.performance.title': 'Teljesítmény követése',
  'dash.performance.body': 'Lásd a bevételt és a kifizetéseket egy helyen.',

  // ---- CTA ----
  'cta.title': 'Csatlakozz az AI-alapú divatfelfedezés következő generációjához',
  'cta.body':
    'Érd el azokat a vásárlókat, akiknek valóban a te márkád való. Legyél az Outfino partnere!',
  'cta.become': 'Legyél partner',
  'cta.contactSales': 'Kapcsolat',

  // ---- Footer ----
  'footer.tagline': 'Személyre szabott divatfelfedezés a kedvenc márkákkal.',
  'footer.product': 'Termék',
  'footer.company': 'Cég',
  'footer.legal': 'Jogi',
  'footer.privacy': 'Adatvédelem',
  'footer.terms': 'Feltételek',
  'footer.rights': 'Minden jog fenntartva.',

  // ---- Login ----
  'login.back': 'Vissza a főoldalra',
  'login.title': 'Partner Portál',
  'login.subtitle': 'Jelentkezz be a márkád kezeléséhez.',
  'login.email': 'E-mail cím',
  'login.password': 'Jelszó',
  'login.submit': 'Bejelentkezés',
  'login.loading': 'Bejelentkezés…',
  'login.wrongCredentials': 'Hibás e-mail vagy jelszó.',
  'login.networkError': 'Hálózati hiba. Próbáld újra.',
  'login.notice': 'Jelentkezz be az Outfino fiókoddal.',
  'login.google': 'Bejelentkezés Google-lel',
  'login.apple': 'Bejelentkezés Apple-lel',
  'login.or': 'vagy',
  'login.googleFailed': 'Google bejelentkezés sikertelen.',
  'login.googleCloseWindow': 'Bejelentkezve. Ezt az ablakot bezárhatod.',
  'login.appleUnavailable': 'Apple bejelentkezés nem elérhető.',
  'login.appleFailed': 'Apple bejelentkezés sikertelen.',

  // ---- Dashboard shell ----
  'shell.brand': 'Márka',
  'shell.envDev': 'DEV',
  'shell.logout': 'Kijelentkezés',
  'shell.loading': 'Betöltés…',
  'shell.refresh': 'Frissítés',
  'group.mobile': 'Outfino Mobile App',
  'tab.embedded-stats': 'Statisztikák',
  'tab.embedded-visitors': 'Látogatók',
  'shell.comingSoon': 'Hamarosan elérhető.',
  'sidebar.expand': 'Kinyitás',
  'sidebar.collapse': 'Összecsukás',
  'sidebar.menu': 'Menü',
  'sidebar.menuClose': 'Menü bezárása',
  'theme.light': 'Világos',
  'theme.dark': 'Sötét',
  'theme.lightTitle': 'Világos téma',
  'theme.darkTitle': 'Sötét téma',
  'lang.name': 'Magyar',
  'lang.switchTitle': 'Angolra váltás',
  'shell.connectedReturn': 'A boltod csatlakoztatva van az Outfinóhoz.',
  'shell.openPortal': 'Átlépés az Outfino Partnersbe',
  'shell.notLinked': 'Ez a bolt még nincs Outfino fiókhoz kapcsolva.',
  'shell.linkAccount': 'Összekapcsolás az Outfino Partnersben',
  'shell.openInShopifyAdmin': 'Shopify admin',
  'return.title': 'A boltod csatlakoztatva van',
  'return.body':
    'Folytasd az Outfino partner portálon — ott kezelheted a márkádat, a termékeidet és a kifizetéseidet.',
  'shell.embeddedNoSession':
    'Nyisd meg ezt az oldalt a Shopify adminban, az Alkalmazások › Outfino alatt.',

  // ---- No brand yet ----
  'empty.title': 'Még nincs márkád',
  'empty.body':
    'Csatlakoztasd a Shopify áruházadat, hogy létrehozd a márkádat az Outfinón. Automatikusan importáljuk a termékeidet és mindent beállítunk.',
  'empty.create': 'Adj hozzá egy új brandet',

  // ---- Connect Shopify modal ----
  'shopify.title': 'Shopify csatlakoztatása',
  'shopify.body':
    'Add meg a Shopify áruházad domainjét a csatlakoztatáshoz. Átirányítunk a Shopify-ra a hozzáférés jóváhagyásához, majd visszahozunk ide.',
  'shopify.shopLabel': 'Shopify áruház domain',
  'shopify.shopPlaceholder': 'a-boltod.myshopify.com',
  'shopify.connect': 'Csatlakoztatás',
  'shopify.cancel': 'Mégse',
  'shopify.invalid': 'Adj meg egy érvényes .myshopify.com domaint.',

  // ---- Linking a store back from Shopify ----
  'connect.linking': 'Bolt csatolása a fiókodhoz…',
  'connect.syncing': 'Szinkronizálás…',
  'connect.syncingHint': 'A bolt összekapcsolása az Outfino fiókoddal. Ez csak néhány másodperc.',
  'connect.returning': 'Átirányítás az Outfino Partnersbe…',
  'connect.returningHint': 'Ez a bolt még nincs Outfino fiókhoz kapcsolva. Jelentkezz be az Outfino Partnersbe az összekapcsoláshoz.',
  'connect.returningLink': 'Tovább az Outfino Partnersbe',
  'connect.failed':
    'Nem sikerült csatolni a boltot. Próbáld újra a „Brand hozzáadása” gombbal.',
  'connect.alreadyLinked': 'Ez a bolt már egy másik Outfino fiókhoz tartozik.',

  // ---- Shopify-kapcsolat sáv (documents#637) ----
  'connection.reauthTitle':
    'A Shopify-kapcsolat megszakadt — nyisd meg az Outfino appot a Shopify Adminban az újracsatlakozáshoz.',
  'connection.reauthCta': 'Outfino app megnyitása a Shopifyban',
  'products.inactive': 'Inaktív',
  'brandInactive.title': 'A márka jelenleg inaktív.',
  'brandInactive.body': 'A termékei nem jelennek meg az Outfino appban, és nem vásárolhatók meg.',
  'brandInactive.contact': 'Az újraaktiváláshoz vedd fel a kapcsolatot az Outfino adminisztrátoraival.',
  'brandInactive.cta': 'Kapcsolatfelvétel',
  'brandInactive.mailSubject': 'Inaktív márka',
  'connection.disconnectedTitle': 'Az Outfino app nincs telepítve ebben a boltban.',
  'connection.disconnectedCta': 'Telepítés / újracsatlakozás',
  'connection.lastOk': 'Utoljára sikeres: {time}',
  'connection.lastOkNever': 'Még nem volt sikeres kapcsolat',
  'connection.err.tokenExpired': 'A Shopify hozzáférési token lejárt.',
  'connection.err.tokenRejected': 'A Shopify visszautasította vagy visszavonta a hozzáférési tokent.',
  'connection.err.scopeMissing':
    'Hiányzik egy jogosultság ({scope}) — engedélyezd a hiányzó jogosultságot az app megnyitásával.',
  'connection.err.uninstalled': 'Az app el lett távolítva a boltból.',
  'connection.err.generic': 'Ok: {code}',

  // ---- Brand dashboard tabs ----
  'tab.profile': 'Profil',
  'tab.products': 'Termékek',
  'tab.stats': 'Statisztikák',
  'tab.orders': 'Rendelések',
  'orders.title': 'Rendelések',
  'orders.hint': 'Minden, ami az Outfinón keresztül kelt el és neked kell teljesítened. Az összegek a jutalék utáni részed.',
  'orders.loading': 'Rendelések betöltése…',
  'orders.loadError': 'A rendeléseket nem sikerült betölteni.',
  'orders.empty': 'Még nincs rendelés.',
  'orders.units': '{n} tétel',
  'orders.subtotal': 'Termékek',
  'orders.shipping': 'Szállítás',
  'orders.yourShare': 'A te részed ({n}% jutalék után)',
  'orders.method': 'Szállítási mód',
  'orders.deliverTo': 'Kiszállítás ide',
  'orders.shopifyOrder': 'Shopify rendelés',
  'orders.noShopifyOrder': 'Nem jött létre a Shopifyban',

  // ---- Szállítás (#623 B4 — csak olvasás; a Shopify az egyetlen forrás) ----
  'tab.shipping': 'Szállítás',
  'shipping.title': 'Szállítási lefedettség',
  'shipping.source': 'A szállítási országokat és módokat a Shopify beállításaidból olvassuk.',
  'shipping.sourceHowTo': 'A lefedettséget és a díjakat a Shopify Adminban módosíthatod (Settings → Shipping and delivery). A változás automatikusan átjön az Outfinóba, vagy használd a Frissítés gombot.',
  'shipping.refresh': 'Frissítés',
  'shipping.refreshing': 'Frissítés…',
  'shipping.loading': 'Szállítási lefedettség betöltése…',
  'shipping.loadError': 'A szállítási lefedettséget nem sikerült betölteni.',
  'shipping.noCoverage': 'A Shopify beállításaidban még nincs szállítási zóna.',
  'shipping.countryCount': '{n} ország',
  'shipping.restOfWorldChip': 'A világ többi része',
  'shipping.zoomIn': 'Nagyítás',
  'shipping.zoomOut': 'Kicsinyítés',
  'shipping.legendCovered': 'Shopify-lefedett ország',
  'shipping.legendRestOfWorld': 'A világ többi része — minden más ország',
  'shipping.legendNone': 'Nincs szállítás',
  'shipping.pickCountry': 'Válassz egy kiemelt országot, hogy lásd az ott elérhető szállítási módokat.',
  'shipping.shopifyMethodsHead': 'Shopify módok',
  'shipping.methodsLoading': 'Módok betöltése…',
  'shipping.methodsError': 'Az ország szállítási módjait nem sikerült betölteni.',
  'shipping.methodsEmpty': 'Ehhez az országhoz nincs elérhető szállítási mód.',
  'shipping.methodsEmptyButCovered': 'A Shopify beállításaid szerint ide elvileg szállítasz, de a Shopify most nem adott konkrét módot ehhez az országhoz.',
  'shipping.methodsEmptyCheckoutHint': 'A konkrét díjat a vevő címére a Shopify számolja ki a pénztárnál.',
  'shipping.priceAtCheckout': 'Ár a fizetésnél',
  'shipping.notConnectedTitle': 'Kösd össze a Shopify boltod',
  'shipping.notConnectedBody': 'Kösd össze a Shopify boltod, hogy lásd, mely országokba és milyen módokkal szállítasz.',
  'shipping.accessDeniedTitle': 'Frissítsd a Shopify kapcsolatot',
  'shipping.accessDeniedBody': 'Nem tudjuk kiolvasni a szállítási beállításaidat — a Shopify kapcsolatból hiányzik a szállítási jogosultság. Kérjük, kösd össze újra a boltot, hogy megadd.',
  'shipping.genericErrorTitle': 'A szállítás nem elérhető',
  'shipping.genericErrorBody': 'A szállítási beállításaidat most nem sikerült kiolvasni a Shopifyból. Kérjük, próbáld újra később.',
  // documents#637 — visszautasított token (shopify_reauth_required), ill. a
  // hiányzó read_shipping jogosultság (shipping_access_denied + scope_missing).
  'shipping.reauthTitle': 'Csatlakoztasd újra a Shopify boltod',
  'shipping.reauthBody':
    'A Shopify-kapcsolat megszakadt — nyisd meg az Outfino appot a Shopify Adminban az újracsatlakozáshoz.',
  'shipping.scopeMissingTitle': 'Jogosultság kell a szállítási beállításokhoz',
  'shipping.scopeMissingBody':
    'A szállítási beállítások olvasásához jogosultság kell — nyisd meg az Outfino appot a Shopify Adminban, és fogadd el a kért jogosultságot.',
  'shipping.openShopifyApp': 'Outfino app megnyitása a Shopifyban',
  // #623 — a cache-elt lefedettség állapota, amire a vásárlói szűrés épül.
  'shipping.statusValid': 'Szinkronban a Shopify-jal, frissítve: {time}',
  'shipping.statusStale': 'Az adat {days} napja nem frissült — ellenőrizd a Shopify-kapcsolatot',
  'shipping.statusStaleNoDate': 'A lefedettségi adat elavult lehet — ellenőrizd a Shopify-kapcsolatot',
  'shipping.statusUnknown': 'Nem sikerült beolvasni a Shopify szállítási beállításait — nyisd meg az Outfino appot a Shopify Adminban, vagy ellenőrizd a jogosultságokat',

  'tab.payouts': 'Kifizetések',
  'tab.members': 'Tagok',
  'tab.drops': 'Dropok',
  'tab.campaigns': 'Creator kampányok',
  'tab.challenges': 'Játékok',
  'tab.special': 'Speciális',

  // ---- Creator campaigns ----
  'campaigns.title': 'Creator kampányok',
  'campaigns.new': 'Új brief',
  'campaigns.empty': 'Még nem hoztál létre briefet. Kezdd az elsővel!',
  'campaigns.back': 'Vissza',
  'campaigns.applicantsCount': '{count} jelentkező',
  'campaigns.selectedCount': '{done}/{total} kiválasztva',
  'campaigns.applicants': 'Jelentkezők',
  'campaigns.noApplicants': 'Erre a briefre még nem jelentkezett senki.',
  'campaigns.selected': 'Kiválasztva',
  'campaigns.select': 'Kiválasztás',
  'campaigns.deselect': 'Elvetés',
  'campaigns.slots': '{count} creator kell',
  'campaigns.videos': '{count} videó / creator',
  'campaigns.applyDeadline': 'Jelentkezési határidő',
  'campaigns.deliveryDeadline': 'Leadási határidő',
  'campaigns.status.open': 'Nyitott',
  'campaigns.status.selecting': 'Kiválasztás alatt',
  'campaigns.status.in_progress': 'Folyamatban',
  'campaigns.status.completed': 'Lezárult',
  // New brief form
  'campaigns.newTitle': 'Új brief létrehozása',
  'campaigns.fTitle': 'Cím',
  'campaigns.fDescription': 'Leírás',
  'campaigns.fSlots': 'Hány creator kell?',
  'campaigns.fVideos': 'Videó / creator',
  'campaigns.fPayment': 'Díjazás',
  'campaigns.fPaymentPh': 'pl. Jóváhagyott videónként díjazás + bónusz',
  'campaigns.create': 'Brief létrehozása',
  'campaigns.creating': 'Létrehozás...',
  'campaigns.cancel': 'Mégse',
  'campaigns.fAmount': 'Összeg',
  'campaigns.fAmountPh': 'pl. 150',
  'campaigns.fCurrency': 'Pénznem',
  'campaigns.loading': 'Kampányok betöltése...',
  'campaigns.error': 'Nem sikerült betölteni a kampányokat. Próbáld újra.',

  // ---- Brand profile ----
  'profile.title': 'Márkaprofil',
  'profile.logo': 'Logó módosítása',
  'profile.cover': 'Borítókép módosítása',
  'profile.coverHint': 'Adj hozzá borítóképet',
  'profile.name': 'Márkanév',
  'profile.company': 'Cégnév',
  'profile.tagline': 'Szlogen',
  'profile.taglineHint': 'Egy sor a márkanév alatt az appban (max. 140 karakter)',
  'profile.description': 'Leírás',
  'profile.phone': 'Telefonszám',
  'profile.website': 'Weboldal',
  'profile.address': 'Cím',
  'profile.iban': 'IBAN (kifizetésekhez)',
  'profile.visibility': 'A márka látható az Outfinóban',
  'profile.save': 'Mentés',
  'profile.saving': 'Mentés…',
  'profile.saved': 'Mentve.',
  'profile.saveError': 'Nem sikerült menteni. Próbáld újra.',
  'profile.readOnly': 'Nincs jogosultságod a márka szerkesztéséhez.',

  // ---- Products ----
  'products.title': 'Termékek',
  'products.empty':
    'Még nincsenek termékek. Szinkronizáld a Shopify katalógust az importáláshoz.',
  'products.sync': 'Termékek szinkronizálása',
  'products.syncing': 'Szinkronizálás…',
  'products.syncStarted': 'A szinkronizálás elindult — ez eltarthat egy ideig.',
  'products.openInShopify': 'Megnyitás a Shopifyban',
  'products.search': 'Termékek keresése',
  'products.noMatch': 'Nincs a keresésnek megfelelő termék.',
  'products.loadError': 'Nem sikerült betölteni a termékeket.',
  'products.retry': 'Újra',
  'products.soldOut': 'Elfogyott',
  'products.stockCount': '{n} db készleten',
  'products.stockUntracked': 'Nincs készletkövetés',
  'products.stockVariantsOut': '{total} változatból {out} elfogyott',
  // #615 — szinkron folyamatjelző + a besorolásból kimaradt termékek.
  'products.syncProgress': 'Termékek szinkronizálása',
  'products.syncCount': '{done} / {total}',
  'products.syncPreparing': 'Katalógus beolvasása…',
  'products.excludedTitle': 'Nem ruházatként felismert termékek',
  'products.excludedHint':
    'Ezek a termékek szinkronizálódtak, de a besoroló nem ruházatként ismerte fel őket, ezért a vásárlók nem látják őket az Outfinón.',
  // documents#188 — termékenkénti AI-címkézés státusz (ai_labeling a listán).
  'products.labelPending': 'Címkézés folyamatban…',
  'products.labelDone': 'Címkézve',
  'products.labelDoneCategory': 'Címkézve: {category}',
  'products.labelFailed': 'Címkézés sikertelen',
  'products.labelSkipped': 'Nem címkézhető',
  'products.labelRetry': 'Újra',
  'products.labelRetrying': 'Sorba állítás…',
  'products.labelNotLabelable': 'Ez a termék nem címkézhető (törölt, vagy nincs Shopify-adata).',
  'products.labelRetryFailed': 'Nem sikerült elindítani a címkézést. Próbáld újra.',
  'products.disputeAction': 'Hibás besorolás?',
  'products.disputeTitle': 'Hibás besorolás jelzése',
  'products.disputeVerdictNotClothing': 'Az AI szerint: nem ruha',
  'products.disputeAskClothing': 'Felülvizsgálatot kérsz, hogy a termék „ruha” besorolást kapjon.',
  'products.disputeMessage': 'Üzenet (nem kötelező)',
  'products.disputeMessageHint': 'Miért gondolod, hogy hibás a besorolás?',
  'products.disputeSubmit': 'Felülvizsgálat kérése',
  'products.disputeSending': 'Küldés…',
  'products.disputeCancel': 'Mégse',
  'products.disputePending': 'Felülvizsgálat folyamatban',
  'products.disputeRejected': 'Kérelem elutasítva',
  'products.disputeSentOn': 'Beküldve: {date}',
  'products.disputeApprovedAs': 'Ruhaként szerepel',
  'products.disputeApprovedAsCategory': 'Ruhaként szerepel · {category}',
  'products.disputeNoReason': 'Az admin nem írt indoklást.',
  'products.disputeAgain': 'Új kérés',
  'products.disputeApproved': 'Kérelem elfogadva',
  'products.disputeNotDisputable': 'Ez a termék most nem kifogásolható (törölt, vagy még címkézés alatt áll).',
  'products.disputeFailed': 'Nem sikerült elküldeni a kérést. Próbáld újra.',

  // ---- Drops ----
  'drops.title': 'Dropok',
  'drops.empty': 'Még nincsenek dropok.',
  'drops.status.scheduled': 'Ütemezett',
  'drops.status.active': 'Aktív',
  'drops.status.completed': 'Lezárult',
  'drops.status.cancelled': 'Törölve',
  'drops.new': 'Új drop',
  'drops.cancel': 'Törlés',
  'drops.cancelFailed': 'Nem sikerült törölni a dropot. Próbáld újra.',
  'drops.exclusiveBadge': 'Outfino Exclusive',
  'drops.form.title': 'Új drop',
  'drops.form.products': 'Termékek',
  'drops.form.productsHint': 'Válaszd ki a dropba kerülő termékeket. Csak olyan ruházati termék ütemezhető, ami a Shopify boltodban Draft vagy Unlisted státuszú.',
  'drops.form.search': 'Termékek keresése',
  'drops.form.noProducts': 'Nincs ütemezhető termék: nincs olyan Draft vagy Unlisted ruházati termék, ami még nem szerepel dropban. Állíts egy terméket Draft vagy Unlisted státuszra a Shopifyban, és szinkronizáld a termékeket, hogy ütemezhesd.',
  'drops.form.selected': '{n} kiválasztva',
  'drops.form.date': 'A drop dátuma és időpontja',
  'drops.form.create': 'Drop ütemezése',
  'drops.form.where': 'Hol jelenjen meg?',
  'drops.form.modeExclusive': 'Outfino Exclusive',
  'drops.form.modeExclusiveHint': 'Csak az Outfinón. A Shopify webshopodban a termékek Draft/Unlisted státuszban maradnak.',
  'drops.form.modeBoth': 'Outfino + saját webshop',
  'drops.form.modeBothHint': 'A drop időpontjában a Shopify boltodban is Aktívra állítjuk a termékeket.',
  'drops.form.noDate': 'Még nincs időpont',
  'drops.form.close': 'Bezárás',
  'drops.form.creating': 'Ütemezés…',
  'drops.form.failed': 'Nem sikerült ütemezni a dropot. Próbáld újra.',
  'drops.form.created': '{n} termék ütemezve.',
  'drops.form.createdSkipped': '{n} termék ütemezve, {skipped} kimaradt (már szerepel egy dropban, nem ruházati termék, vagy már nem Draft/Unlisted).',

  // ---- Stats ----
  'stats.title': 'Statisztikák',
  'stats.available': 'Elérhető egyenleg',
  'stats.totalEarned': 'Összes bevétel',
  'stats.thisMonth': 'Ebben a hónapban',
  'stats.orders': 'Rendelések',
  'stats.revenue': 'Bevétel',
  'stats.payouts': 'Kifizetések',
  'stats.noPayouts': 'Még nincs kifizetés.',
  'stats.period.day': 'Nap',
  'stats.period.week': 'Hét',
  'stats.period.month': 'Hónap',
  'stats.period.year': 'Év',
  'stats.period.all': 'Összes',

  // ---- Payouts ----
  'payouts.title': 'Kifizetések',
  'payouts.request': 'Kifizetés igénylése',
  'payouts.requesting': 'Igénylés…',
  'payouts.requested': 'Kifizetési igény elküldve.',
  'payouts.requestError': 'Nem sikerült elküldeni az igényt. Próbáld újra.',
  'payouts.pending': 'Függőben',
  'payouts.history': 'Kifizetési előzmények',
  'payouts.commissionNote': '{pct}% Outfino-jutalék levonása után',
  'payouts.breakdownTitle': 'Bevétel bontása',
  'payouts.gross': 'Bruttó bevétel',
  'payouts.commissionLine': 'Outfino-jutalék ({pct}%)',
  'payouts.net': 'Nettó – a tiéd',

  // ---- Members ----
  'members.title': 'Tagok',
  'members.empty': 'Még nincsenek tagok.',
  'members.anonymous': 'Névtelen',
  'members.role.owner': 'Tulajdonos',
  'members.role.member': 'Tag',
  'members.devLocked': 'Fejlesztői brandhez nem adhatsz hozzá új tagot.',
  'members.add': 'Új tag',
  'members.searchPlaceholder': 'Keresés felhasználónévre…',
  'members.searchEmpty': 'Nincs találat.',
  'members.remove': 'Eltávolítás',

  // ---- Permissions ----
  'perm.viewProducts': 'Termékek megtekintése',
  'perm.editProducts': 'Termékek szerkesztése',
  'perm.viewOrders': 'Rendelések megtekintése',
  'perm.viewAnalytics': 'Statisztikák megtekintése',
  'perm.manageMembers': 'Tagok kezelése',
  'perm.manageCampaigns': 'Kampányok kezelése',
  'perm.editBrand': 'Márka szerkesztése',
  'perm.manageBilling': 'Számlázás kezelése',

  // ---- Danger zone (delete brand) ----
  'danger.title': 'Veszélyzóna',
  'danger.deleteBrand': 'Márka eltávolítása',
  'danger.deleteBody': 'Az Outfino lekerül a Shopify boltodról, a termékeid eltűnnek az Outfinóról, a márkából pedig minden tag kikerül, téged is beleértve. Aki legközelebb csatlakoztatja a boltot, az lesz az új tulajdonos. Ez nem vonható vissza.',
  'danger.confirm': 'Biztosan eltávolítod a(z) {name} márkát? Ez nem vonható vissza.',
  'danger.error': 'Nem sikerült eltávolítani a márkát. Próbáld újra.',
  'danger.deleting': 'Eltávolítás…',
  // ---- Challenges / galaxy gift drops (GiftDropsTab) ----
  'gifts.title': 'Ajándékláda a galaxisban',
  'gifts.lead': 'Dobj be egy ládát az Outfino app Style Universe galaxisába. Kívülről úszik be, kb. 100 másodperc alatt átúszik a galaxison, és aki elsőként megérinti, elviszi. Ha senki nem kapja el, kiúszik.',
  'gifts.dropButton': 'Ajándék bedobása a galaxisba',
  'gifts.dropped': 'A láda úton van a galaxisba.',
  'gifts.cancelled': 'A ládát visszavontad.',
  'gifts.activeTitle': 'Aktív ládák',
  'gifts.polling': 'Frissítés {s} mp-enként',
  'gifts.pollingTitle': 'Az oldal magától frissül: gyakrabban, amíg láda úszik a galaxisban.',
  'gifts.live': 'Élő',
  'gifts.liveTitle': 'Élő kapcsolat: a változások azonnal megjelennek.',
  'gifts.err.brandInactive': 'A márkád most nem látható az Outfinón, ezért nem dobhatsz be ládát.',
  'gifts.err.notEligible': 'Ez a márka most nem dobhat be ládát a galaxisba.',
  'gifts.err.followersOnly': 'Ezt a ládát csak a márka követői kaphatják el.',
  'gifts.err.brandNotFound': 'Ez a márka nem található.',
  'gifts.followersOnly': 'Csak követőknek',
  'gifts.followersOnlyTitle': 'Csak a márkád követői kaphatják el; a többiek láncokkal lezárva látják.',
  'gifts.modal.followersOnly': 'Csak követőknek',
  'gifts.modal.followersOnlyHint': 'Akik nem követik a brandet, a ládát láncokkal lezárva látják, és nem kaphatják el.',
  'gifts.retry': 'Újra',
  'gifts.noActive': 'Most nincs ládád a galaxisban.',
  'gifts.historyTitle': 'Előzmények',
  'gifts.noHistory': 'Még nem dobtál be ládát.',
  'gifts.loadMore': 'Továbbiak betöltése',
  'gifts.someone': 'Valaki',
  'gifts.seconds': '{n} mp',
  'gifts.cancel': 'Visszavonás',
  'gifts.cancelTitle': 'Visszavonod a ládát?',
  'gifts.cancelText': 'A láda (bedobva: {at}) azonnal eltűnik a galaxisból, és senki sem kaphatja el. Ez nem vonható vissza.',
  'gifts.cancelling': 'Visszavonás…',
  'gifts.cancelConfirm': 'Igen, visszavonom',
  'gifts.phase.incoming': 'beúszik a galaxisba',
  'gifts.phase.inside': 'a peremig',
  'gifts.phase.leaving': 'kiúszik a galaxisból',
  'gifts.status.active': 'Aktív',
  'gifts.status.collected': 'Elkapták',
  'gifts.status.expired': 'Kiúszott',
  'gifts.status.cancelled': 'Visszavonva',
  'gifts.col.createdAt': 'Létrehozva',
  'gifts.col.status': 'Státusz',
  'gifts.col.winner': 'Nyertes',
  'gifts.col.reaction': 'Reakcióidő',
  'gifts.col.crossing': 'Átkelés',
  'gifts.modal.title': 'Ajándék bedobása a galaxisba',
  'gifts.modal.logoTitle': 'A ládán a te logód látszik',
  'gifts.modal.logoText': 'Mindenki látja, aki éppen a galaxist nézi az appban.',
  'gifts.modal.text': 'A láda a galaxis peremén kívülről úszik be, kb. 100 másodperc alatt széltől szélig átúszik, és aki az Outfino appban elsőként megérinti, elviszi. Ha senki nem kapja el, kiúszik.',
  'gifts.modal.reward': 'Ajándék',
  'gifts.modal.rewardSoon': 'Ajándék (kupon) — hamarosan',
  'gifts.modal.rewardHint': 'Hamarosan kupont is tehetsz a ládába. Addig a láda ajándék nélkül úszik.',
  'gifts.modal.note': 'Megjegyzés (nem kötelező)',
  'gifts.modal.notePlaceholder': 'Pl. őszi kampány — csak nektek látszik',
  'gifts.modal.back': 'Mégse',
  'gifts.modal.dropping': 'Bedobás…',
  'gifts.modal.confirm': 'Bedobom',
  'gifts.err.galaxyFull': 'Most túl sok láda úszik a galaxisban, próbáld újra pár perc múlva.',
  'gifts.err.notActive': 'Ez a láda már nincs a galaxisban.',
  'gifts.err.notActiveStatus': 'Ez a láda már nincs a galaxisban ({status}).',
  'gifts.err.notFound': 'Ez a láda nem található.',
  'gifts.err.invalid': 'Valamelyik mező hibás. Ellenőrizd a megjegyzést, és próbáld újra.',
  'gifts.err.disabled': 'A ládák bedobása most nem elérhető.',
  'gifts.err.forbidden': 'Ehhez a márkához nincs jogosultságod ládát bedobni.',
  'gifts.err.auth': 'Lejárt a bejelentkezésed. Jelentkezz be újra.',
  'gifts.err.rateLimited': 'Túl sok kérés egyszerre. Várj egy kicsit, és próbáld újra.',
  'gifts.err.network': 'Nem érjük el a szervert. Ellenőrizd a kapcsolatot, és próbáld újra.',
  'gifts.err.unavailable': 'Ez a funkció itt még nem érhető el.',
  'gifts.err.genericCode': 'Valami hiba történt ({code}). Próbáld újra.',
  'gifts.err.generic': 'Valami hiba történt. Próbáld újra.',
  'gifts.modal.prize': 'Nyeremény (nem kötelező)',
  'gifts.modal.prizeHint': 'Aki elkapja a ládát, ezeket a termékeidet kapja ingyen a kosarába (mindegyikből 1 db, legfeljebb {max} termék).',
  'gifts.modal.prizeAdd': 'Termék hozzáadása',
  'gifts.prize.label': 'Nyeremény',
  'gifts.prize.none': 'Nyeremény nélkül',
  'gifts.prize.freeShip': 'ingyenes szállítással',
  'gifts.col.prize': 'Nyeremény',
  'gifts.err.freeShipping': 'A termékes ládához fogadd el, hogy a szállítás ingyenes (a költségét te állod).',
  'gifts.err.product.product_not_found': 'Az egyik termék nem található. Válaszd ki újra a termékeket.',
  'gifts.err.product.product_inactive': 'Az egyik termék nem aktív, ezért nem lehet nyeremény.',
  'gifts.err.product.product_out_of_stock': 'Az egyik termék elfogyott, ezért nem lehet nyeremény.',
  'gifts.err.product.duplicate_product': 'Ugyanaz a termék kétszer szerepel.',
  'gifts.err.product.too_many_products': 'Egy ládában legfeljebb 5 termék lehet.',
  // ---- Challenges: prize wheel (Szerencsekerék) + the game switcher ----
  'games.label': 'Játékok',
  'games.gifts.title': 'Ajándékláda',
  'games.gifts.text': 'Átúszik a galaxison — aki elkapja, viszi',
  'games.wheel.title': 'Szerencsekerék',
  'games.wheel.text': 'A boltod mellett, élő sorsolással',
  'wheel.title': 'Szerencsekerék',
  'wheel.lead': 'Ütemezz egy nyereményjátékot a termékeiddel: a kerék a boltod mellett áll az Outfino térképén, a felhasználók az appban csatlakoznak, a sorsolást pedig te indítod el élőben — igazságosan és ellenőrizhetően.',
  'wheel.scheduleButton': 'Szerencsekerék ütemezése',
  'wheel.oneAtATime': 'Egyszerre egy aktív szerencsekereked lehet. Újat akkor ütemezhetsz, ha ezt kisorsoltuk vagy visszavontad.',
  'wheel.scheduled': 'Ütemezve! A kerék megjelent a boltod mellett a térképen.',
  'wheel.updated': 'A változásokat elmentettük.',
  'wheel.cancelled': 'A szerencsekereket visszavontad.',
  'wheel.currentTitle': 'Aktuális kerék',
  'wheel.pollingTitle': 'Az oldal magától frissül: gyakrabban, amíg a kerék ütemezve van vagy pörög.',
  'wheel.noActive': 'Most nincs szerencsekereked a térképen.',
  'wheel.historyTitle': 'Korábbi kerekek',
  'wheel.noHistory': 'Még nincs korábbi szerencsekereked.',
  'wheel.status.scheduled': 'Ütemezve',
  'wheel.status.drawing': 'Sorsolás folyamatban',
  'wheel.status.finished': 'Lezárult',
  'wheel.status.cancelled': 'Visszavonva',
  'wheel.opensAtChip': 'Csatlakozás: {at}',
  'wheel.joinOpen': 'Csatlakozás nyitva',
  'wheel.edit': 'Szerkesztés',
  'wheel.cancel': 'Visszavonás',
  'wheel.stat.untilDraw': 'Sorsolásig',
  'wheel.stat.spinEnds': 'A sorsolás végéig',
  'wheel.stat.drawnAt': 'Kisorsolva',
  'wheel.stat.participants': 'Résztvevők',
  'wheel.stat.winners': 'Nyertesek',
  'wheel.stat.opensIn': 'Csatlakozásig',
  'wheel.drawingNow': 'Az appban most pörög a kerék.',
  'wheel.countdownDays': '{d} nap {hms}',
  'wheel.lock.joined': 'Már csatlakoztak a kerékhez, ezért nem szerkeszthető; visszavonni még lehet.',
  'wheel.lock.soon': 'A sorsolás előtti utolsó 10 percben már nem szerkeszthető.',
  'wheel.lock.generic': 'Ez a kerék már nem szerkeszthető.',
  'wheel.winnersTitle': 'Nyertesek',
  'wheel.winnersError': 'A nyerteseket most nem sikerült betölteni.',
  'wheel.noParticipants': 'Senki nem csatlakozott, így nem volt nyertes.',
  'wheel.noWinners': 'Nincs nyertes.',
  'wheel.noWinnersShort': 'Nincs',
  'wheel.winnersN': '{n} nyertes',
  'wheel.someone': 'Valaki',
  'wheel.anonymous': 'privát profil',
  'wheel.round': '{n}. kör',
  'wheel.entryIndexTitle': 'A nyertes pont sorszáma a keréken (0-tól)',
  'wheel.details': 'Részletek',
  'wheel.cancelledAt': 'Visszavonva: {at}. Nem volt sorsolás.',
  'wheel.proof.title': 'Ellenőrizhető sorsolás',
  'wheel.proof.seedHash': 'Ujjlenyomat (seed hash)',
  'wheel.proof.seed': 'Titkos kulcs (seed)',
  'wheel.proof.seedHidden': 'A sorsolás után jelenik meg',
  'wheel.proof.textScheduled': 'Az ujjlenyomatot már az ütemezéskor rögzítettük; a hozzá tartozó titkos kulcsot a sorsolás után tesszük közzé, így az eredményt utólag senki nem igazíthatja.',
  'wheel.proof.textFinished': 'A titkos kulcs már nyilvános: bárki ellenőrizheti, hogy az ujjlenyomata egyezik, és hogy belőle ugyanezek a nyertesek jönnek ki.',
  'wheel.proof.check': 'Ellenőrzés most',
  'wheel.proof.checking': 'Ellenőrzés…',
  'wheel.proof.ok': 'Egyezik: az ujjlenyomat és a nyertesek is stimmelnek.',
  'wheel.proof.okHash': 'Az ujjlenyomat egyezik.',
  'wheel.proof.badHash': 'Az ujjlenyomat nem egyezik a kulccsal.',
  'wheel.proof.badWinners': 'A kulcsból más nyertesek jönnek ki.',
  'wheel.proof.checkError': 'Ebben a böngészőben most nem tudjuk ellenőrizni.',
  'wheel.proof.copy': '{what} másolása',
  'wheel.proof.howTitle': 'Hogyan ellenőrizhető?',
  'wheel.proof.how1': 'Ütemezéskor a szerver egy 32 bájtos véletlen kulcsot sorsol, és csak az SHA-256 ujjlenyomatát teszi közzé.',
  'wheel.proof.how2': 'A sorsoláskor a résztvevők a csatlakozás sorrendjében 0-tól kapnak sorszámot.',
  'wheel.proof.how3': 'Körönként a nyertes sorszáma ebből jön (torzításmentes választással, a korábbi nyertesek kizárásával):',
  'wheel.proof.how3Code': 'HMAC-SHA256(kulcs, "{id}:<kör>:<próba>")',
  'wheel.cancelTitle': 'Visszavonod a szerencsekereket?',
  'wheel.cancelText': 'A(z) „{title}” kerék azonnal eltűnik a térképről, és a {at} időpontra tervezett sorsolás elmarad. Ez nem vonható vissza.',
  'wheel.cancelJoined': 'Már {n} felhasználó csatlakozott.',
  'wheel.cancelling': 'Visszavonás…',
  'wheel.cancelConfirm': 'Igen, visszavonom',
  'wheel.form.createTitle': 'Szerencsekerék ütemezése',
  'wheel.form.editTitle': 'Szerencsekerék szerkesztése',
  'wheel.form.back': 'Mégse',
  'wheel.form.title': 'Cím',
  'wheel.form.titlePlaceholder': 'Pl. Őszi kollekció sorsolás',
  'wheel.form.titlePreview': 'A kerék címe',
  'wheel.form.prize': 'Nyeremény',
  'wheel.form.prizePlaceholder': 'Pl. 1 db táska az őszi kollekcióból, ingyenes szállítással',
  'wheel.form.winners': 'Nyertesek száma',
  'wheel.form.winnersHint': '1–{max} nyertes; egymás után sorsoljuk ki őket.',
  'wheel.form.winnersLocked': 'Ütemezés után nem módosítható.',
  'wheel.form.less': 'Kevesebb',
  'wheel.form.more': 'Több',
  'wheel.form.opens': 'Csatlakozás kezdete',
  'wheel.form.opensNow': 'Azonnal',
  'wheel.form.opensLater': 'Későbbi időpontban',
  'wheel.form.opensDate': 'A csatlakozás napja',
  'wheel.form.opensTime': 'A csatlakozás órája',
  'wheel.form.draw': 'Sorsolás időpontja',
  'wheel.form.drawDate': 'A sorsolás napja',
  'wheel.form.drawTime': 'A sorsolás órája',
  'wheel.form.quick.inHour': '1 óra múlva',
  'wheel.form.quick.tomorrow': 'Holnap 20:00',
  'wheel.form.quick.week': '1 hét múlva, 20:00',
  'wheel.form.drawHint': 'Legalább 10 perccel a csatlakozás kezdete után, legfeljebb 30 nappal előre.',
  'wheel.form.rules': 'Elfogadom a játékszabályzatot',
  'wheel.form.rulesHint': 'A sorsolás az Outfino játékszabályzata szerint zajlik; ütemezés előtt el kell fogadnod.',
  'wheel.form.schedule': 'Ütemezés',
  'wheel.form.scheduling': 'Ütemezés…',
  'wheel.form.save': 'Mentés',
  'wheel.form.saving': 'Mentés…',
  'wheel.form.fix': 'Nézd át a pirossal jelölt mezőket.',
  'wheel.form.err.titleRequired': 'Adj címet a keréknek.',
  'wheel.form.err.titleTooLong': 'Legfeljebb 80 karakter.',
  'wheel.form.err.prizeRequired': 'Írd le, mit lehet nyerni.',
  'wheel.form.err.prizeTooLong': 'Legfeljebb 500 karakter.',
  'wheel.form.err.winners': '1 és 10 közötti szám.',
  'wheel.form.err.opensRequired': 'Add meg a csatlakozás kezdetét.',
  'wheel.form.err.drawRequired': 'Add meg a sorsolás napját és óráját.',
  'wheel.form.err.drawTooSoon': 'A sorsolás legalább 10 perccel a csatlakozás kezdete után legyen.',
  'wheel.form.err.drawTooLate': 'Legfeljebb 30 nappal előre ütemezhetsz.',
  'wheel.form.err.rules': 'Az ütemezéshez fogadd el a játékszabályzatot.',
  'wheel.form.err.server': 'A szerver ezt a mezőt nem fogadta el.',
  'wheel.how.mapTitle': 'A térképen.',
  'wheel.how.map': 'Ütemezés után a kerék megjelenik a boltod mellett az Outfino térképén.',
  'wheel.how.joinTitle': 'Csatlakozás az appban.',
  'wheel.how.join': 'A felhasználók az appban csatlakoznak, a csatlakozás kezdetétől a sorsolásig — a beállításod szerint mindenki vagy csak a követőid.',
  'wheel.how.drawTitle': 'Élő sorsolás.',
  'wheel.how.draw': 'A sorsolás időpontjában te indítod el a kereket (akár élő adásban); az eredmény ellenőrizhető.',
  'wheel.preview.countLabel': 'résztvevő',
  'wheel.preview.label': '{name} szerencsekereke 3D-ben',
  'wheel.preview.hint': 'Húzd a forgatáshoz',
  'wheel.preview.spin': 'Próbapörgetés',
  'wheel.preview.spinning': 'Pörög…',
  'wheel.preview.noGl': 'A 3D előnézethez WebGL kell.',
  'wheel.preview.error': 'Az előnézetet most nem sikerült betölteni.',
  'wheel.preview.drawChip': 'Sorsolás: {at}',
  'wheel.preview.caption': 'Előnézet a márkád színeivel. A pontok a csatlakozókat jelölik (itt példaként {n}).',
  'wheel.col.drawAt': 'Sorsolás',
  'wheel.col.wheel': 'Kerék',
  'wheel.col.status': 'Állapot',
  'wheel.col.participants': 'Résztvevők',
  'wheel.col.winners': 'Nyertesek',
  'wheel.col.details': 'Részletek',
  'wheel.err.activeExists': 'Egyszerre csak egy aktív szerencsekereked lehet. A meglévőt sorsoljuk ki, vagy vond vissza, és utána ütemezhetsz újat.',
  'wheel.err.locked': 'Ez a kerék már nem szerkeszthető: csatlakoztak hozzá, vagy közel a sorsolás.',
  'wheel.err.notCancellable': 'Ezt a kereket már nem lehet visszavonni — a sorsolás elindult vagy lezárult.',
  'wheel.err.notFound': 'Ez a szerencsekerék nem található.',
  'wheel.err.invalid': 'Valami nem stimmel az űrlapon. Nézd át, és próbáld újra.',
  'wheel.err.invalidField': 'A szerver nem fogadta el ezt a mezőt: {field}.',
  'wheel.err.brandInactive': 'A márkád most nem látható az Outfinón, ezért nem ütemezhet szerencsekereket.',
  'wheel.err.notEligible': 'Ez a márka most nem ütemezhet szerencsekereket.',
  'wheel.err.disabled': 'A szerencsekerék most nem érhető el.',
  'wheel.err.forbidden': 'Nincs jogosultságod szerencsekereket kezelni ennél a márkánál.',
  'wheel.err.brandNotFound': 'Ez a márka nem található.',
  'wheel.err.auth': 'Lejárt a bejelentkezésed. Jelentkezz be újra.',
  'wheel.err.rateLimited': 'Túl sok kérés egyszerre. Várj egy kicsit, és próbáld újra.',
  'wheel.err.network': 'Nem érjük el a szervert. Ellenőrizd a kapcsolatot, és próbáld újra.',
  'wheel.err.unavailable': 'Ez a funkció itt még nem érhető el.',
  'wheel.err.genericCode': 'Valami hiba történt ({code}). Próbáld újra.',
  'wheel.err.generic': 'Valami hiba történt. Próbáld újra.',
  'wheel.free.accept': 'Tudomásul veszem: a nyertes a terméket és a szállítást is ingyen kapja, a szállítás költségét én állom.',
  'wheel.form.err.freeShipping': 'Az ütemezéshez fogadd el az ingyenes szállítást.',
  'wheel.form.err.roundTooMany': 'Egy körben legfeljebb 5 különböző termék lehet.',
  'wheel.form.productOut': 'Nem elérhető',
  'wheel.err.rounds.product_not_found': 'A(z) {round}. kör egyik terméke nem található.',
  'wheel.err.rounds.product_inactive': 'A(z) {round}. kör egyik terméke nem aktív.',
  'wheel.err.rounds.product_out_of_stock': 'A(z) {round}. kör egyik terméke elfogyott.',
  'wheel.err.rounds.duplicate_product': 'A(z) {round}. körben kétszer szerepel ugyanaz a termék.',
  'wheel.err.rounds.too_many_products': 'A(z) {round}. körben túl sok a termék (legfeljebb 5).',
  'wheel.err.rounds.empty_round': 'A(z) {round}. kör üres.',
  'wheel.err.rounds.too_many_rounds': 'Legfeljebb 10 kör lehet.',
  'wheel.status.ready': 'Sorsolásra kész',
  'wheel.free.title': 'Ingyenes nyeremény, ingyenes szállítás.',
  'wheel.free.text': 'A nyertes a terméke(ke)t ingyen kapja a kosarába, és a szállítás is kötelezően ingyenes — a szállítás költségét te állod.',
  'wheel.form.rounds': 'Nyeremények körönként',
  'wheel.form.roundsHint': 'Minden kör egy pörgetés és egy nyertes, aki a kör összes termékét megkapja (mindegyikből 1 db, körönként legfeljebb 5 termék). Legfeljebb 10 kör. Csak aktív, raktáron lévő termék lehet nyeremény.',
  'wheel.form.roundAdd': 'Kör hozzáadása',
  'wheel.form.roundUp': '{n}. kör feljebb',
  'wheel.form.roundDown': '{n}. kör lejjebb',
  'wheel.form.roundRemove': '{n}. kör törlése',
  'wheel.form.roundEmptyHint': 'Még nincs termék',
  'wheel.form.productsN': '{n} termék',
  'wheel.form.productsAdd': 'Termékek hozzáadása',
  'wheel.form.productsEdit': 'Termékek módosítása',
  'wheel.form.productSearch': 'Keresés a termékeid között',
  'wheel.form.productsPicked': '{n}/{max} kiválasztva',
  'wheel.form.productsDone': 'Kész',
  'wheel.form.productsNone': 'Még nincs terméked az Outfinón. Szinkronizáld őket a Termékek oldalon.',
  'wheel.form.productsNoMatch': 'Nincs ilyen termék.',
  'wheel.form.productsError': 'A termékeidet most nem sikerült betölteni.',
  'wheel.form.productRemove': '{name} eltávolítása',
  'wheel.form.exclude': 'Aki egy korábbi körben nyert, ne nyerhessen újra',
  'wheel.form.excludeHint': 'Így minden kör más nyertest kap.',
  'wheel.form.prizeOptional': 'Leírás (nem kötelező)',
  'wheel.form.prizeAutoHint': 'Ha üresen hagyod, a termékekből állítjuk össze.',
  'wheel.form.autoSummaryRound': '{n}. kör: {names}',
  'wheel.form.eligibility': 'Kik nevezhetnek?',
  'wheel.eligibility.followers_at_schedule': 'Csak a jelenlegi követők',
  'wheel.eligibility.followers_at_scheduleHint': 'Akik már most követnek; az új követők kizárva.',
  'wheel.eligibility.followers': 'Követők',
  'wheel.eligibility.followersHint': 'Új követők is nevezhetnek.',
  'wheel.eligibility.everyone': 'Mindenki',
  'wheel.eligibility.everyoneHint': 'Követéstől függetlenül bárki nevezhet.',
  'wheel.excludeOn': 'Egy ember egyszer nyerhet',
  'wheel.excludeOff': 'Többször is lehet nyerni',
  'wheel.form.err.roundsCount': '1 és 10 közötti kör kell.',
  'wheel.form.err.roundEmpty': 'Minden körbe tegyél legalább egy terméket.',
  'wheel.form.err.eligibility': 'Válaszd ki, kik nevezhetnek.',
  'wheel.preview.roundsChip': '{n} kör',
  'wheel.stat.rounds': 'Körök',
  'wheel.stat.autoStart': 'Automatikus indulásig',
  'wheel.readyNow': 'A csatlakozás lezárult — indítsd el a sorsolást!',
  'wheel.prizesTitle': 'Nyeremények',
  'wheel.resultsTitle': 'Eredmények körönként',
  'wheel.noWinnerRound': 'Nem volt nyertes',
  'wheel.live.ready': 'Sorsolásra kész',
  'wheel.live.start': 'Sorsolás indítása',
  'wheel.live.starting': 'Indítás…',
  'wheel.live.waiting': 'A sorsolást a márka indítja el.',
  'wheel.live.auto': 'Ha 30 mp-en belül nem indítod, automatikusan elindul ({s} mp).',
  'wheel.live.startsIn': 'Indul: {s} mp',
  'wheel.live.spinning': '{n}. kör / {total} — pörög',
  'wheel.live.roundWinner': '{n}. kör nyertese',
  'wheel.live.done': 'A sorsolás véget ért',
  'wheel.live.fullscreen': 'Teljes képernyő',
  'wheel.live.exitFullscreen': 'Kilépés',
  'wheel.err.notReady': 'A sorsolás még nem indítható.',
  'wheel.err.alreadyDrawn': 'A sorsolás már elindult.',
  'wheel.err.products': 'Valamelyik termék nem használható nyereményként. Nézd át a köröket.',
  'wheel.err.socket': 'Nincs élő kapcsolat a szerverrel. Próbáld újra; ha nem indítod, 30 mp után magától elindul.',
  // ---- Dev banner ----
  'dev.bannerFull': 'Fejlesztői mód — az éles verzióhoz látogass el ide: ',
  'dev.bannerShort': 'Fejlesztői mód — ',
  'dev.userBannerFull': 'Fejlesztői mód — dev felhasználóként vagy bejelentkezve',
  'dev.userBannerShort': 'Dev felhasználó',

  'tab.discounts': "Kedvezmények",
  'tab.calendar': "Eseménynaptár",
  'tab.prizePool': "Prize Pool",
  'discounts.title': "Kedvezmények",
  'discounts.subtitle': "Automatikus kedvezmények és kuponkódok az Outfino vásárlóinak. Minden a Shopify boltodban is létrejön, és szinkronban marad vele.",
  'discounts.new': "Új kedvezmény",
  'discounts.section.automatic': "Automatikus kedvezmények",
  'discounts.section.code': "Kuponok",
  'discounts.empty.automatic': "Még nincs automatikus kedvezmény.",
  'discounts.empty.code': "Még nincs kupon. Hozz létre egy kódot, amit a vásárlók a kosárban beírhatnak.",
  'discounts.sync': "Szinkronizálás a Shopifyjal",
  'discounts.syncing': "Szinkronizálás…",
  'discounts.synced': "A kedvezmények szinkronban vannak a Shopifyjal.",
  'discounts.created': "{code} létrehozva a Shopifyban és az Outfinóban.",
  'discounts.pause': "Szüneteltetés",
  'discounts.resume': "Folytatás",
  'discounts.delete': "Törlés",
  'discounts.confirmDelete': "Törlöd: {code}? A Shopify boltodból is törlődik.",
  'discounts.usage': "{used}× használva",
  'discounts.usageOf': "{used} / {limit} használva",
  'discounts.minSubtotal': "{amount} felett",
  'discounts.minQuantity': "{n} darabtól",
  'discounts.allProducts': "Minden termék",
  'discounts.productCount': "{n} termék",
  'discounts.oncePerCustomer': "Vásárlónként egyszer",
  'discounts.fromShopify': "Shopifyból",
  'discounts.method.automatic': "Automatikus kedvezmény",
  'discounts.method.code': "Kuponkód",
  'discounts.status.active': "Aktív",
  'discounts.status.scheduled': "Ütemezett",
  'discounts.status.paused': "Szüneteltetve",
  'discounts.status.expired': "Lejárt",
  'discounts.status.used_up': "Elfogyott",
  'discounts.form.titleCoupon': "Új kupon",
  'discounts.form.kind': "Fajta",
  'discounts.form.shopify': "Shopify",
  'discounts.form.shopifySync': "Szinkron a Shopifyjal",
  'discounts.form.shopifyLocal': "Csak Outfino",
  'discounts.form.localNote': "A kedvezmény csak az Outfinón működik, a Shopify boltodban nem jön létre. A kifizetésedből ugyanúgy levonódik.",
  'discounts.syncedShopify': "Shopifyjal szinkronban",
  'discounts.outfinoOnly': "Csak Outfino",
  'discounts.createdLocal': "{code} létrehozva az Outfinón.",
  'discounts.confirmDeleteLocal': "Törlöd: {code}?",
  'discounts.currency': "Bolt pénzneme: {currency}",
  'discounts.form.title': "Új kedvezmény",
  'discounts.form.close': "Bezárás",
  'discounts.form.methodHint.automatic': "Fizetéskor automatikusan érvényesül, ha a feltételek teljesülnek — a vásárlónak nem kell kódot beírnia.",
  'discounts.form.methodHint.code': "A vásárló a kosárban írja be a kódot.",
  'discounts.form.code': "Kód",
  'discounts.form.codeHint': "3–32 karakter: betűk, számok, - és _",
  'discounts.form.name': "Név",
  'discounts.form.nameHint': "A vásárlók a kosárban látják",
  'discounts.form.namePlaceholder': "pl. Őszi akció",
  'discounts.form.type': "Típus",
  'discounts.form.typePercentage': "Százalékos",
  'discounts.form.typeFixed': "Fix összeg",
  'discounts.form.valuePercent': "Kedvezmény (%)",
  'discounts.form.valueAmount': "Kedvezmény összege ({currency})",
  'discounts.form.products': "Termékek",
  'discounts.form.allProducts': "Minden termék",
  'discounts.form.searchProducts': "Termékek keresése…",
  'discounts.form.noProducts': "Még nincs termék.",
  'discounts.form.selected': "{n} kiválasztva",
  'discounts.form.condition': "Feltétel",
  'discounts.form.conditionNone': "Nincs",
  'discounts.form.conditionSubtotal': "Minimum összeg",
  'discounts.form.conditionQuantity': "Minimum darab",
  'discounts.form.minSubtotal': "Minimum vásárlás ({currency})",
  'discounts.form.minQuantity': "Minimum darabszám",
  'discounts.form.usageLimit': "Összes felhasználás",
  'discounts.form.optional': "Opcionális",
  'discounts.form.startsAt': "Kezdete",
  'discounts.form.startsHint': "Üres = azonnal",
  'discounts.form.endsAt': "Vége",
  'discounts.form.oncePerCustomer': "Vásárlónként egyszer",
  'discounts.form.shopifyNote': "A kedvezmény a Shopify boltodban is létrejön, és a kifizetésedből vonódik le.",
  'discounts.form.cancel': "Mégse",
  'discounts.form.create': "Létrehozás",
  'discounts.form.creating': "Létrehozás…",
  'discounts.error.taken': "Ez a kód már létezik.",
  'discounts.error.invalid': "A Shopify elutasította a kedvezményt. Ellenőrizd az értékeket, és próbáld újra.",
  'discounts.error.reauth': "Az Outfinónak engedély kell a kedvezmények kezeléséhez a Shopify boltodban. Nyisd meg az Outfino appot a Shopifyban, és hagyd jóvá a frissített jogosultságokat.",
  'discounts.error.createFailed': "Nem sikerült létrehozni a kedvezményt. Próbáld újra.",
  'discounts.error.syncFailed': "Nem sikerült szinkronizálni a Shopifyjal. Próbáld újra.",
  'discounts.error.updateFailed': "Nem sikerült módosítani a kedvezményt. Próbáld újra.",
  'discounts.error.deleteFailed': "Nem sikerült törölni a kedvezményt. Próbáld újra.",
  // ---- Custom brand building (3D) + support chat ----
  'shell.support': 'Támogatás',

  'building.sectionTitle': 'Így jelenik meg a márkád az Outfinóban',
  'building.sectionLeadGeneric': 'Ez az alap Outfino bolt a Style Universe térképen, a te logóddal a cégéreken és a borítóddal a tetőn álló reklámtáblán. Forgasd körbe!',
  'building.sectionLeadCustom': 'A márkád egyedi épülete él a Style Universe térképen — így látják a vásárlók. Forgasd körbe!',
  'building.badgeGeneric': 'Alap bolt',
  'building.badgeCustom': 'Egyedi épület',
  'building.priceNoteLabel': 'Egyedi brand épület',
  'building.cta': 'Szeretnék egy egyedileg tervezett épületet az Outfinóban',
  'building.redesign': 'Újratervezés',
  'building.redesignConfirmTitle': 'Valóban új épületet akarsz tervezni?',
  'building.redesignConfirmBody': 'A mostani épületed addig marad a térképen, amíg az új el nem készül.',
  'building.redesignCancel': 'Mégse',
  'building.redesignConfirm': 'Igen, újratervezem',
  'building.redesignPrefix': 'Újratervezés: ',
  'building.redesignNote': 'Újratervezés — írd le, mit változtatnál a mostani épületeden.',
  'building.openThreadTitle': 'Folyamatban lévő beszélgetés',
  'building.openThreadBody': 'Az egyedi épületed ügyében már beszélgetünk — nézd meg a legújabb üzeneteket.',
  'building.openThreadLanding': 'Az egyedi épületed ügyében már folyik egy beszélgetés velünk. Ott tudod kiegészíteni vagy módosítani a kérésed.',
  'building.openThreadCta': 'Beszélgetés megnyitása',
  'building.viewerLabel': '{name} boltja 3D-ben',
  'building.viewerHint': 'húzd a forgatáshoz',
  'building.viewerError': 'A 3D előnézet most nem tölthető be.',
  'building.viewerNoGl': 'Ez a böngésző nem támogatja a 3D előnézetet.',
  'building.closedSignText': 'Zárva',
  'building.logoShapeLabel': 'Logó forma az alapbolton',
  'building.logoShape.round': 'Kerek',
  'building.logoShape.square': 'Négyzet',
  'building.logoShape.rect': 'Téglalap',
  'building.logoShapeHint': 'A választott forma azonnal látszik az előnézeten, és így kerül a térképre is.',
  'building.logoShapeReadOnly': 'A logó formáját szerkesztési joggal lehet módosítani.',
  'building.logoShapeSaving': 'Mentés…',
  'building.logoShapeSaved': 'Mentve — a térképen is ez a forma látszik.',
  'building.logoShapeError': 'Nem sikerült menteni, visszaállítottuk az előzőt. Próbáld újra.',
  'building.closedInactive': 'A boltod jelenleg Zárva állapotban látszik a térképen, mert a márkád inaktív.',
  'building.closedNoShopify': 'A boltod jelenleg Zárva állapotban látszik a térképen, mert nincs aktív Shopify-kapcsolat.',
  'building.closedGeneric': 'A boltod jelenleg Zárva állapotban látszik a térképen.',
  'building.closedHintInactive': 'Kapcsold be lent „A márka látható az Outfinóban” beállítást, vagy vedd fel velünk a kapcsolatot — utána a bolt újra kinyit.',
  'building.closedHintNoShopify': 'Kösd össze a Shopify boltodat az Outfinóval (Outfino app a Shopify adminban) — utána a bolt magától kinyit.',
  'building.closedCtaShopify': 'Shopify összekötése',
  'building.previewToggle': 'Nyitva / Zárva előnézet',
  'building.previewOpen': 'Nyitva',
  'building.previewClosed': 'Zárva',
  // ---- Style category: which Style Universe galaxy the store stands in ----
  'styleCategory.label': 'Stíluskategória',
  'styleCategory.explainer': 'Ez határozza meg, melyik stílusgalaxisban áll a boltod a térképen.',
  'styleCategory.prompt': 'Válaszd ki a stílusodat, hogy a boltod a megfelelő galaxisba kerüljön.',
  'styleCategory.saving': 'Mentés…',
  'styleCategory.saved': 'Mentve — a boltod mostantól ebben a galaxisban áll: {galaxy}.',
  'styleCategory.error': 'Nem sikerült menteni, visszaállítottuk az előzőt. Próbáld újra.',
  'styleCategory.readOnly': 'A stíluskategóriát szerkesztési joggal lehet módosítani.',
  'styleCategory.readOnlyNone': 'Még nincs kiválasztva stíluskategória. Szerkesztési joggal lehet beállítani.',
  'styleCategory.name.streetwear': 'Streetwear',
  'styleCategory.name.techwear': 'Techwear',
  'styleCategory.name.goth_alt': 'Goth / Alt',
  'styleCategory.name.experimental': 'Kísérletező',
  'styleCategory.name.y2k': 'Y2K',
  'styleCategory.name.sporty': 'Sporty',
  'styleCategory.name.casual': 'Hétköznapi',
  'styleCategory.name.boho_indie': 'Boho / Indie',
  'styleCategory.name.minimalist': 'Minimalista',
  'styleCategory.name.old_money': 'Old Money',
  'styleCategory.name.vintage_retro': 'Vintage / Retro',

  'building.backToProfile': 'Vissza a profilhoz',
  'building.eyebrow': 'Style Universe · Egyedi brand épület',
  'building.heroTitle': 'Saját épület a márkádnak az Outfino galaxisában',
  'building.heroLead': 'Az alap bolt helyett egy rád szabott, körbejárható 3D épület áll a márkádnak a Style Universe térképen — a te formavilágoddal, anyagaiddal és színeiddel. A vásárlók már messziről felismernek.',
  'building.priceLabel': 'Ár',
  'building.priceFrom': 'bruttó {price} Ft-tól',
  'building.heroCta': 'Kérem az egyedi épületet',
  'building.heroCtaRedesign': 'Újratervezést kérek',
  'building.heroGallery': 'Megnézem a galériát',
  'building.processTitle': 'Így készül',
  'building.processLead': '3 tervváltozatot küldünk, utána még 2 módosítási kört kérhetsz.',
  'building.step1Title': 'Elmondod, mit szeretnél',
  'building.step1Body': 'Írd le, milyen épületet képzelsz el, és küldj hozzá referenciákat (fotók, Pinterest, a boltod).',
  'building.step2Title': '3 tervváltozat',
  'building.step2Body': 'Tervezőnk három különböző koncepciót készít a márkád arculata alapján.',
  'building.step3Title': '2 módosítási kör',
  'building.step3Body': 'A kiválasztott változaton még két körben kérhetsz módosításokat.',
  'building.step4Title': 'Élesítés a térképen',
  'building.step4Body': 'A kész épület a logóddal és a borítóddal együtt felkerül a Style Universe térképre.',
  'building.galleryTitle': 'Egyedi épületek az Outfinóban',
  'building.galleryLead': 'Ezek a márkák már saját épülettel szerepelnek. Kattints egyre, és forgasd körbe 3D-ben.',
  'building.galleryOpen': '{name} épületének megnyitása 3D-ben',
  'building.galleryEmptyTitle': 'Még nincs egyedi épület',
  'building.galleryEmptyBody': 'Legyen a tiéd az első a Style Universe térképen!',
  'building.galleryError': 'A galéria most nem tölthető be.',
  'building.retry': 'Újra',
  'building.close': 'Bezárás',
  'building.formTitle': 'Kérd az egyedi épületedet',
  'building.formTitleRedesign': 'Kérd az épületed újratervezését',
  'building.formLead': 'Az ár bruttó {price} Ft-tól indul. A kérésedből egy beszélgetés indul a csapatunkkal a Támogatásban — ott egyeztetjük a részleteket és az árajánlatot.',
  'building.fieldDescription': 'Milyen épületet szeretnél?',
  'building.fieldDescriptionHint': 'Pl. „Fekete, kétszintes mini villa üvegfallal, belül világos tölgy polcok…” — forma, anyagok, színek, hangulat, bármi, ami fontos.',
  'building.fieldDescriptionError': 'Írj legalább pár szót arról, mit szeretnél.',
  'building.fieldLinks': 'Referencia linkek',
  'building.fieldLinksHint': 'Nem kötelező. Pinterest, Instagram, a boltod fotói, épületek, amik tetszenek.',
  'building.linkAdd': 'Link hozzáadása',
  'building.linkRemove': 'Link törlése',
  'building.fieldEmail': 'Kapcsolattartó e-mail',
  'building.submit': 'Beszélgetés indítása',
  'building.submitRedesign': 'Újratervezés kérése',
  'building.submitFine': 'A küldés nem jár kötelezettséggel — előbb árajánlatot adunk.',
  'building.sending': 'Küldés…',
  'building.sendError': 'Nem sikerült elküldeni. Próbáld újra egy kicsit később.',

  'support.title': 'Támogatás',
  'support.lead': 'Írj nekünk bármiben — a beszélgetéseidet itt találod, és itt válaszolunk.',
  'support.new': 'Új beszélgetés',
  'support.listLabel': 'Beszélgetések',
  'support.noThreads': 'Még nincs beszélgetésed.',
  'support.listError': 'A beszélgetések most nem tölthetők be.',
  'support.topic.general': 'Általános kérdés',
  'support.topic.brand_building': 'Egyedi brand épület',
  'support.closed': 'Lezárva',
  'support.pickTitle': 'Válassz egy beszélgetést',
  'support.pickBody': 'vagy indíts egy újat a jobb felső gombbal.',
  'support.back': 'Beszélgetések',
  'support.newTitle': 'Új beszélgetés',
  'support.newLead': 'Miben segíthetünk? A csapatunk itt válaszol.',
  'support.newLabel': 'Üzenet',
  'support.newHint': 'Írd le a kérdésed…',
  'support.start': 'Küldés',
  'support.sending': 'Küldés…',
  'support.sendError': 'Nem sikerült elküldeni. Próbáld újra.',
  'support.conversation': 'Beszélgetés',
  'support.started': 'Indítva: {date}',
  'support.createdNotice': 'Megkaptuk, hamarosan jelentkezünk! A válaszunkat itt találod.',
  'support.noMessages': 'Még nincs üzenet.',
  'support.notFound': 'Ez a beszélgetés nem található.',
  'support.loadError': 'Az új üzenetek most nem tölthetők be.',
  'support.outfinoTeam': 'Outfino csapat',
  'support.composerHint': 'Írj üzenetet…',
  'support.closedHint': 'Lezárt beszélgetés — ha írsz, új beszélgetést nyitunk.',
  'support.send': 'Küldés',
  'building.sendInvalid': 'Valami nem stimmel a megadott adatokkal — ellenőrizd a leírást és a linkeket (http/https).',
  'support.alreadyOpenNotice': 'Erről már folyik egy beszélgetés — itt tudod folytatni.',
  'support.retry': 'Nem ment el — újra',
  // ---- QA fixes (fix/ui-qa-contrast): confirmations, payout states ----
  'nav.demo': 'Csatlakozás',
  'confirm.back': 'Mégse',
  'drops.cancelConfirmTitle': 'Törlöd a dropot?',
  'drops.cancelConfirmBody': 'A(z) „{name}” ütemezett dropja törlődik, és nem jelenik meg az appban.',
  'drops.cancelConfirm': 'Drop törlése',
  'members.removeConfirmTitle': 'Eltávolítod a tagot?',
  'members.removeConfirmBody': '{name} elveszíti a hozzáférését a márkához.',
  'payouts.confirmTitle': 'Kifizetés igénylése',
  'payouts.confirmBody': 'A teljes elérhető egyenleget ({amount}) kéred kifizetésre. A kérés után ez az összeg függőbe kerül.',
  'payouts.pendingBlocks': 'Már van függőben lévő kifizetési igényed — új igényt akkor küldhetsz, ha az lezárult.',
  'payouts.status.pending': 'Függőben',
  'payouts.status.processing': 'Feldolgozás alatt',
  'payouts.status.completed': 'Kifizetve',
  'payouts.status.failed': 'Sikertelen',
  'payouts.status.cancelled': 'Visszavonva',

  // ── Fit-check embed (Statisztikák / Látogatók / Beállítások) ──
  'tab.embedded-settings': 'Beállítások',
  'embed.range.label': 'Időszak',
  'embed.range.days': '{n} nap',
  'embed.range.custom': 'Egyéni',
  'embed.range.from': 'Kezdete',
  'embed.range.to': 'Vége',
  'embed.mock.badge': 'Tesztadatok',
  'embed.mock.title': 'Ezek tesztadatok, nem valódi forgalom.',
  'embed.error.load': 'Nem sikerült betölteni az adatokat. Próbáld újra a Frissítés gombbal.',
  'embed.error.forbidden': 'Ehhez az oldalhoz nincs jogosultságod ennél a márkánál.',
  'embed.empty.range': 'Ebben az időszakban még nincs adat.',
  'embed.copy.button': 'Másolás',
  'embed.copy.codeDone': 'A beágyazó kód a vágólapon van',
  'embed.copy.failed': 'Nem sikerült a másolás. Jelöld ki a kódot, és másold kézzel.',

  'embed.stats.title': 'Fit-check gomb statisztika',
  'embed.stats.lead': 'Mit csinált a „Nézd meg, hogy passzol-e hozzád” gomb a termékoldalaidon: hányan látták, kattintottak, léptek be, töltöttek fel fotót és nézték meg a product matchinget.',
  'embed.kpi.impressions': 'Megjelenések',
  'embed.kpi.clicks': 'Kattintások',
  'embed.kpi.signups': 'Regisztrációk',
  'embed.kpi.logins': 'Belépések',
  'embed.kpi.matchViews': 'Matching megtekintések',
  'embed.kpi.uploadSessions': 'Feltöltések',
  'embed.kpi.photosUploaded': 'Feltöltött fotók',
  'embed.kpi.uniqueVisitors': 'Egyedi látogatók',
  'embed.kpi.ctr': 'Átkattintás: {pct}',
  'embed.kpi.perUpload': 'Átlag {n} fotó / feltöltés',
  'embed.funnel.title': 'Tölcsér',
  'embed.funnel.impressions': 'Megjelenés',
  'embed.funnel.clicks': 'Kattintás',
  'embed.funnel.signIns': 'Regisztráció vagy belépés',
  'embed.funnel.matchViews': 'Product matching megtekintés',
  'embed.funnel.conv': '{pct} az előző lépésből',
  'embed.funnel.signInsHint': '{signups} új · {logins} visszatérő',
  'embed.funnel.uploadSessions': 'feltöltés',
  'embed.funnel.photos': 'feltöltött fotó',
  'embed.funnel.uploadRate': 'a belépők közül töltött fel fotót',
  'embed.chart.title': 'Napi alakulás',
  'embed.chart.metricLabel': 'Mutató',
  'embed.chart.metric.impressions': 'Megjelenések',
  'embed.chart.metric.clicks': 'Kattintások',
  'embed.chart.metric.signIns': 'Regisztrációk + belépések',
  'embed.chart.metric.matchViews': 'Matching megtekintések',
  'embed.chart.metric.photosUploaded': 'Feltöltött fotók',
  'embed.chart.showTable': 'Napi bontás táblázatban',
  'embed.chart.hideTable': 'Táblázat elrejtése',
  'embed.chart.date': 'Nap',
  'embed.top.title': 'Termékek',
  'embed.top.lead': 'Melyik termékoldal hozta a regisztrációkat, a matching megtekintéseket és a feltöltött fotókat, és mennyire illettek a termékek a látogatókhoz.',
  'embed.top.product': 'Termék',
  'embed.top.col.impressions': 'Megjelenés',
  'embed.top.col.clicks': 'Kattintás',
  'embed.top.col.signups': 'Regisztráció',
  'embed.top.col.matchViews': 'Matching',
  'embed.top.col.photosUploaded': 'Fotó',
  'embed.top.col.avgCompatibility': 'Átl. kompatibilitás',

  'embed.visitors.title': 'Látogatók',
  'embed.visitors.lead': 'Ki mit csinált a gombbal, melyik termékednél. Csak a bejelentkezett Outfino-felhasználók szerepelnek itt; a névtelen kosarak és vásárlások a Statisztikák összesítőiben látszanak.',
  'embed.visitors.product': 'Termék',
  'embed.visitors.allProducts': 'Minden termék',
  'embed.visitors.event': 'Esemény',
  'embed.visitors.allEvents': 'Minden esemény',
  'embed.visitors.empty': 'Nincs a szűrésnek megfelelő látogató ebben az időszakban.',
  'embed.visitors.shown': '{n} esemény',
  'embed.visitors.more': 'Továbbiak betöltése',
  'embed.visitors.col.user': 'Felhasználó',
  'embed.visitors.col.event': 'Esemény',
  'embed.visitors.col.product': 'Termék',
  'embed.visitors.col.photos': 'Fotók',
  'embed.visitors.col.compat': 'Kompatibilitás',
  'embed.visitors.col.time': 'Időpont',
  'embed.event.signup': 'Regisztrált az Outfinóra',
  'embed.event.login': 'Belépett',
  'embed.event.match_view': 'Megnézte a product matchinget',
  'embed.event.uploadOne': '1 képet töltött fel',
  'embed.event.upload': '{n} képet töltött fel',
  'embed.eventFilter.signup': 'Regisztráció',
  'embed.eventFilter.login': 'Belépés',
  'embed.eventFilter.upload': 'Képfeltöltés',
  'embed.eventFilter.match_view': 'Product matching megtekintés',

  'embed.settings.title': 'Fit-check gomb beállításai',
  'embed.status.configured': 'Beállítva',
  'embed.status.notConfigured': 'Nincs beállítva',
  'embed.status.lastSeen': 'Utoljára élő oldalon: {ago}',
  'embed.status.notConfiguredHint': 'Az elmúlt 7 napban nem láttuk a gombot élő oldalon. Tedd ki az alábbi kóddal, és pár percen belül itt jelzünk.',
  'embed.status.domainMeta': '{ago} · {n} megjelenés az elmúlt 7 napban',
  'embed.key.label': 'Embed kulcs',
  'embed.key.masked': 'Embed kulcs, részben elrejtve',
  'embed.key.copyCode': 'Beágyazó kód másolása',
  'embed.key.allowed': 'Engedélyezett domainek: {domains}',
  'embed.design.title': 'A gomb kinézete',
  'embed.design.lead': 'Válaszd ki, melyik illik a boltod témájához. Az előnézetek az élő gombot mutatják.',
  'embed.design.gallery': 'Forma és szín',
  'embed.design.shape.pill': 'Kapszula',
  'embed.design.shape.rounded': 'Lekerekített',
  'embed.design.shape.square': 'Szögletes',
  'embed.design.theme.dark': 'Sötét gomb',
  'embed.design.theme.light': 'Világos gomb',
  'embed.design.variant': 'Szélesség',
  'embed.design.variant.compact': 'Kompakt',
  'embed.design.variant.full': 'Teljes szélesség',
  'embed.design.height': 'Magasság',
  'embed.design.lang': 'Nyelv',
  'embed.design.lang.auto': 'Automatikus (ajánlott)',
  'embed.design.langNote': 'A gomb automatikusan a látogató nyelvén jelenik meg: magyar böngészőben magyarul, mindenhol máshol angolul. A kimásolt kódban ez az alapbeállítás (lang=auto).',
  'embed.design.langForced': 'A gomb minden látogatónak ezen a nyelven jelenik meg: {lang}. Az automatikus beállítással mindenki a saját nyelvén látja.',
  'embed.design.preview': 'Előnézet',
  'embed.design.visitor.hu': 'Magyar nyelvű látogató',
  'embed.design.visitor.en': 'Bármely más nyelvű látogató',
  'embed.install.title': 'Beépítés a boltba',
  'embed.install.platform': 'Platform',
  'embed.install.shopify': 'Shopify (Liquid)',
  'embed.install.html': 'Más webshop (HTML)',
  'embed.install.code': 'Beágyazó kód',
  'embed.install.liquid.title': 'Egyéni Liquid blokk',
  'embed.install.liquid.lead': 'Bármelyik Shopify témában működik, beillesztéssel.',
  'embed.install.liquid.step1': 'Shopify adminban: Online Store → Customize → Product page (Online áruház → Testreszabás → Termékoldal).',
  'embed.install.liquid.step2': 'Add block → Custom Liquid (Egyéni Liquid), oda, ahol a gombot szeretnéd (pl. a Kosárba gomb alá).',
  'embed.install.liquid.step3': 'Illeszd be az alábbi kódot, és mentsd.',
  'embed.install.liquid.vars': 'A kód a Shopify változóiból veszi a termék adatait: {{ product.id }}, {{ product.handle }}, {{ shop.permanent_domain }} és a termék kiemelt képe.',
  'embed.install.html.step1': 'Másold ki az alábbi kódot.',
  'embed.install.html.step2': 'Illeszd be a termékoldal sablonjába, oda, ahol a gombot szeretnéd.',
  'embed.install.html.step3': 'Cseréld ki a helyőrzőket a termék adataira (a webshopod sablonnyelvének változóival).',
  'embed.install.ph.id': 'a termék azonosítója (csak számjegyek)',
  'embed.install.ph.handle': 'a termék URL-neve (pl. organic-cotton-tee)',
  'embed.install.ph.img': 'a termékkép https címe, URL-kódolva',

  // ── Fit-check embed: SRC, carts + purchases, the pixel ──
  'embed.copy.srcDone': 'Az SRC a vágólapon van',
  'embed.copy.snippetDone': 'Kimásolva: {what}',
  'embed.key.copySrc': 'SRC másolása',
  'embed.key.srcLabel': 'Iframe SRC · {platform}',
  'embed.kpi.addToCarts': 'Kosárba tétel',
  'embed.kpi.purchases': 'Vásárlás',
  'embed.kpi.revenueMatched': 'Bevétel matchinggel',
  'embed.kpi.ofWhichMatched': 'ebből matchinggel: {n}',
  'embed.kpi.revenueHint': 'Azok a vásárlások, ahol a vevő előtte megnézte a matchinget annál a terméknél',
  'embed.funnel.addToCartsMatched': 'Kosárba tette (matchinggel)',
  'embed.funnel.purchasesMatched': 'Megvásárolta (matchinggel)',
  'embed.funnel.allCarts': 'összes kosárba tétel: {n}',
  'embed.funnel.allPurchases': 'összes vásárlás: {n}',
  'embed.chart.metric.addToCarts': 'Kosárba tételek',
  'embed.chart.metric.purchases': 'Vásárlások',
  'embed.top.col.addToCarts': 'Kosárba',
  'embed.top.col.purchases': 'Vásárlás',
  'embed.top.col.revenueMatched': 'Bevétel',
  'embed.top.matched': '{n} matchinggel',
  'embed.event.add_to_cart': 'Kosárba tette',
  'embed.event.purchase': 'Megvásárolta',
  'embed.eventFilter.add_to_cart': 'Kosárba tétel',
  'embed.eventFilter.purchase': 'Vásárlás',
  'embed.visitors.qty': '{n} db',
  'embed.visitors.matched': 'matchinggel',
  'embed.visitors.matchedTitle': 'Előtte megnézte a product matchinget ennél a terméknél (30 napon belül)',
  'embed.tracking.title': 'Kosár- és vásárláskövetés',
  'embed.tracking.lead': 'Az Outfino pixel bármely webshopban méri a kosárba tételeket és a vásárlásokat. A statisztikában az összes szám a pixel által látott összes kosár és vásárlás (a névtelen látogatóké is); „matchinggel” az, ahol ugyanaz a látogató az előtte lévő 30 napban megnézte a product matchinget annál a terméknél. A Látogatók listában csak a bejelentkezett Outfino-felhasználók szerepelnek.',
  'embed.tracking.platform.shopify': 'Shopify',
  'embed.tracking.platform.woocommerce': 'WooCommerce',
  'embed.tracking.platform.html': 'Más webshop (HTML)',
  'embed.tracking.lastCart': 'Utolsó kosárba tétel: {ago}',
  'embed.tracking.lastPurchase': 'utolsó vásárlás: {ago}',
  'embed.tracking.notConfiguredHint': 'Még nem érkezett kosár- vagy vásárlásesemény. Kapcsold be az alábbiak szerint.',
  'embed.tracking.seenOn': 'Látott platform:',
  'embed.tracking.seen.shopify': 'Shopify',
  'embed.tracking.seen.woocommerce': 'WooCommerce',
  'embed.tracking.seen.custom': 'Egyedi',
  'embed.tracking.shopify.step1': 'Kosárba tétel minden oldalon: Online Store → Themes → Edit code (Online áruház → Témák → Kód szerkesztése) → theme.liquid. Illeszd be ezt a sort a </body> elé, majd mentsd.',
  'embed.tracking.shopify.step2': 'Vásárlások: Shopify adminban Settings → Customer events → Add custom pixel. Nevezd el „Outfino”-nak, és illeszd be ezt a kódot (a kulcsod már benne van).',
  'embed.tracking.woo.step1': 'Tedd be ezt a két sort minden oldalra, egyszer (pl. egy „header/footer scripts” bővítménnyel).',
  'embed.tracking.woo.step1b': 'Vagy bővítmény nélkül, a téma functions.php-jába:',
  'embed.tracking.woo.phpTitle': 'Opcionális: PHP-részlet a köszönőoldalra',
  'embed.tracking.woo.phpLead': 'A pontos tételekhez és értékhez, a téma functions.php-jába vagy egy kis bővítménybe. Nélküle a pixel a köszönőoldalról olvassa a rendelésszámot és a végösszeget.',
  'embed.tracking.html.step1': 'Tedd be ezt a két sort a webshop minden oldalára, a </head> elé.',
  'embed.tracking.html.step2': 'Kosárba tétel: vagy egy data-attribútum a kosár gombon, vagy egy hívás a saját kosárkódodból.',
  'embed.tracking.html.step3': 'Vásárlás: a rendelés-visszaigazoló oldalon, egyszer, a rendelés adataival.',
  'embed.tracking.code.pixel': 'Pixel',
  'embed.tracking.code.php': 'PHP-részlet',
  'embed.tracking.code.addToCart': 'Kosárba tétel',
  'embed.tracking.code.purchase': 'Vásárlás',
  'embed.tracking.code.consent': 'Hozzájárulás',
  'embed.tracking.consent': 'Az EU-ban a követés csak a látogató hozzájárulása után indulhat; előtte a pixel semmit nem tárol és nem küld. Automatikusan követi a Shopify Customer Privacy API-t, a WP Consent API-t, a Google Consent Mode-ot és az elterjedt cookie-kezelőket (Cookiebot, OneTrust, CookieYes). Ha egyik sincs az oldalon, a hozzájárulás után hívd meg (elutasításnál false-szal):',
  'embed.tracking.shopify.detects': 'Felismeri a téma AJAX-os és űrlapos kosárba tételét; a hozzájáruláshoz a Shopify Customer Privacy API-t használja.',
  'embed.tracking.woo.detects': 'Felismeri a listaoldali AJAX-os és a termékoldali kosárba tételt, a Cart/Checkout blokkokat, és a rendelés-visszaigazoló oldalt.',
  'embed.tracking.code.functions': 'functions.php',
  'embed.tracking.code.addToCartAttr': 'Kosár gomb (data-attribútum)',
  'embed.kpi.allSeen': 'a pixel által látott összes',
  'embed.tracking.shopify.step2b': 'Permission: Analytics, majd Save és Connect.',
  'embed.tracking.code.customPixel': 'Egyéni pixel',
  'embed.tracking.products': 'A termékeket a pixel magától olvassa ki az oldalról (Shopify katalógus, WooCommerce Store API, schema.org JSON-LD), így nincs szükség termékszinkronra.',
  'embed.kpi.follows': 'Új követők (iframe-ből)',
  'embed.funnel.follows': 'követés',
  'embed.chart.metric.follows': 'Új követők',
  'embed.top.col.follows': 'Követés',
  'embed.event.follow': 'Követni kezdte a márkát',
  'embed.eventFilter.follow': 'Követés',
  'embed.copy.keyDone': 'A kulcs a vágólapon van',
  'embed.key.copyKey': 'Kulcs másolása',
  'embed.install.block.title': 'Outfino app blokk',
  'embed.install.block.lead': 'Ha az Outfino Shopify app telepítve van, a gomb egy blokk a témaszerkesztőben.',
  'embed.install.block.step1': 'Shopify adminban: Online Store → Customize (Online áruház → Testreszabás).',
  'embed.install.block.step2': 'Felül válaszd a Product page (termékoldal) sablont, majd Add block → Outfino.',
  'embed.install.block.step3': 'A blokk „Embed key” mezőjébe illeszd be a kulcsodat.',
  'embed.install.block.step4': 'Állítsd be ugyanazt a formát, színt, szélességet és magasságot, amit fent választottál, majd mentsd.',
  'embed.tracking.app.title': 'Outfino app',
  'embed.tracking.app.lead': 'Ha az Outfino Shopify app telepítve van.',
  'embed.tracking.app.step1': 'Online Store → Customize → App embeds (Online áruház → Testreszabás → Alkalmazásbeágyazások).',
  'embed.tracking.app.step2': 'Kapcsold be az „Outfino követés” beágyazást, majd mentsd.',
  'embed.tracking.app.checkout': 'A pénztárban leadott rendeléseket az Outfino app Web Pixele automatikusan küldi.',
  'embed.tracking.paste.title': 'Beillesztéssel',
  'embed.tracking.paste.lead': 'App nélkül, bármelyik Shopify témában.',
  'embed.visitors.guest': 'Vendég',
  'embed.visitors.anonymous': 'Látogató',
  'embed.tracking.inactive': 'Nem aktív',
  'embed.tracking.inactiveHint': 'Az elmúlt 7 napban nem érkezett kosár- vagy vásárlásesemény.',
  'embed.product.untitled': 'Termék #{id}',

  // ── Profil / Követők / Számlázás (top-level brand pages) ──
  'tab.followers': 'Követők',
  'tab.billing': 'Számlázás',

  'brandProfile.title': 'Márkaprofil',
  'brandProfile.logo': 'Logó',
  'brandProfile.logoAdd': 'Logó hozzáadása',
  'brandProfile.logoChange': 'Logó cseréje',
  'brandProfile.logoHint': 'Kör alakban jelenik meg. Négyzetes kép mutat a legjobban.',
  'brandProfile.cover': 'Borítókép',
  'brandProfile.coverAdd': 'Borítókép hozzáadása',
  'brandProfile.coverChange': 'Borítókép cseréje',
  'brandProfile.nameRequired': 'A márkanév nem lehet üres.',
  'brandProfile.preview': 'Előnézet',
  'brandProfile.previewChip': 'A fit-check gombban',
  'brandProfile.previewHeader': 'Fejléc a borítóképpel',
  'brandProfile.tone.light': 'Világos',
  'brandProfile.tone.dark': 'Sötét',
  'brandProfile.follow': 'Követés',

  'followers.title': 'Követők',
  'followers.lead': 'Akik követik a márkát, az appból vagy a fit-check gombból.',
  'followers.count': 'követő',
  'followers.matches': 'találat',
  'followers.search': 'Keresés felhasználónévre',
  'followers.empty': 'Még nincs követő.',
  'followers.noMatch': 'Nincs ilyen nevű követő.',
  'followers.col.user': 'Felhasználó',
  'followers.col.source': 'Honnan',
  'followers.col.since': 'Követés kezdete',
  'followers.source.app': 'Appból',
  'followers.source.embed': 'Fit-check gombból',
  'followers.anon': 'Rejtett profil',
  'followers.anonTitle': 'A felhasználó nem jelenik meg név szerint.',
  'followers.shown': '{n} / {total} látható',
  'followers.more': 'Továbbiak betöltése',

  'billing.loadError': 'Nem sikerült betölteni a számlázási adatokat. Próbáld újra a Frissítés gombbal.',
  'billing.readOnly': 'A kártyát és a számlázási adatokat a márka tulajdonosa módosíthatja.',
  'billing.readOnlyOwner': 'A számlázást a márka tulajdonosa kezeli.',
  'billing.cancel': 'Mégse',
  'billing.term': 'egyedi matching',
  'billing.terms': 'egyedi matching',
  'billing.termTip': 'Egy felhasználó egy terméknél 30 napon belül egyszer számít.',
  'billing.price.title': 'Díjszabás',
  'billing.price.base': 'Havidíj: {fee} (az első hónap ingyenes)',
  'billing.price.included': '{n} {term} benne',
  'billing.price.overage': 'felette {price} / {term} (havonta legfeljebb {cap})',
  'billing.price.commission': '{rate} jutalék a matchinghez köthető vásárlásokból',
  'billing.usage.title': 'Ez a hónap',
  'billing.usage.period': 'Hónap',
  'billing.usage.includedOf': '{term}',
  'billing.usage.over': '+{n} a kereten felül',
  'billing.usage.meterLabel': 'Felhasznált egyedi matchingek a havidíjban foglaltakból',
  'billing.usage.baseFee': 'Havidíj',
  'billing.usage.trial': 'Próbahónap',
  'billing.usage.overage': 'Többlet-matching',
  'billing.usage.overageCalc': '{n} × {price}, legfeljebb {cap}',
  'billing.usage.overageNone': 'A havidíjban foglalt kereten belül (legfeljebb {cap})',
  'billing.usage.capReached': 'elérte a havi felső határt',
  'billing.usage.commission': 'Jutalék ({rate})',
  'billing.usage.commissionCalc': '{n} matchinghez köthető vásárlás, {revenue} forgalom',
  'billing.usage.estimated': 'Várható összeg',
  'billing.usage.total': 'A hónap összege',

  'billing.card.title': 'Bankkártya',
  'billing.card.lead': 'A havi díjat erről a kártyáról vonjuk le.',
  'billing.card.none': 'Még nincs kártya megadva.',
  'billing.card.generic': 'Kártya',
  'billing.card.expires': 'Lejárat: {date}',
  'billing.card.expired': 'Lejárt: {date}',
  'billing.card.add': 'Kártya hozzáadása',
  'billing.card.replace': 'Kártya cseréje',
  'billing.card.remove': 'Eltávolítás',
  'billing.card.removeConfirm': 'Eltávolítod a kártyát? Amíg nincs kártya megadva, a havi díjat nem tudjuk levonni.',
  'billing.card.removeConfirmGate': 'Eltávolítod a kártyát? Kártya nélkül a portál nem érhető el, amíg újat nem adsz meg.',
  'billing.card.removeYes': 'Eltávolítás',
  'billing.card.removing': 'Eltávolítás…',
  'billing.card.removed': 'A kártya eltávolítva',
  'billing.card.removeFailed': 'Nem sikerült eltávolítani a kártyát. Próbáld újra.',
  'billing.card.save': 'Kártya mentése',
  'billing.card.saving': 'Mentés…',
  'billing.card.saved': 'A kártya elmentve',
  'billing.card.saveFailed': 'A kártyát a bank elfogadta, de nem sikerült elmenteni. Próbáld újra.',
  'billing.card.failed': 'Nem sikerült hitelesíteni a kártyát. Próbáld újra, vagy adj meg másik kártyát.',
  'billing.card.processing': 'A bank még feldolgozza a kártyát. Pár perc múlva frissítsd az oldalt.',
  'billing.card.unavailable': 'A kártya megadása most nem érhető el. Próbáld újra később.',

  'billing.mock.note': 'Tesztmód: nincs Stripe-kapcsolat, semmi nem kerül terhelésre. Próbaszámok: 4242 4242 4242 4242 (sikeres), 4000 0027 6000 3184 (3D Secure), 4000 0000 0000 0002 (elutasított).',
  'billing.mock.number': 'Kártyaszám',
  'billing.mock.expiry': 'Lejárat',
  'billing.mock.expiryPh': 'HH / ÉÉ',
  'billing.mock.badNumber': 'Érvénytelen kártyaszám.',
  'billing.mock.badExpiry': 'Érvénytelen vagy lejárt dátum.',
  'billing.mock.badCvc': 'Érvénytelen CVC.',
  'billing.mock.declined': 'A kártyát a bank elutasította.',
  'billing.mock.3dsTitle': 'Hitelesítés a bankodnál',
  'billing.mock.3dsBody': 'A bankod megerősítést kér ehhez a kártyához (3D Secure).',
  'billing.mock.3dsApprove': 'Megerősítés',
  'billing.mock.3dsReject': 'Elutasítás',
  'billing.mock.3dsFailed': 'A 3D Secure hitelesítés nem sikerült. Próbáld újra, vagy adj meg másik kártyát.',

  'billing.details.title': 'Számlázási adatok',
  'billing.details.name': 'Cégnév',
  'billing.details.email': 'Számlázási e-mail',
  'billing.details.taxId': 'Adószám / közösségi adószám',
  'billing.details.taxIdPh': '12345678-2-42 vagy HU12345678',
  'billing.details.line1': 'Cím',
  'billing.details.line2': 'Cím, 2. sor',
  'billing.details.postalCode': 'Irányítószám',
  'billing.details.city': 'Település',
  'billing.details.country': 'Ország',
  'billing.details.save': 'Adatok mentése',
  'billing.details.saved': 'A számlázási adatok elmentve',
  'billing.details.saveFailed': 'Nem sikerült menteni a számlázási adatokat.',
  'billing.details.required': 'Kötelező mező.',
  'billing.details.badEmail': 'Érvénytelen e-mail-cím.',

  'billing.invoices.title': 'Számlák',
  'billing.invoices.empty': 'Még nincs számla.',
  'billing.invoices.number': 'Számlaszám',
  'billing.invoices.period': 'Időszak',
  'billing.invoices.amount': 'Összeg',
  'billing.invoices.status': 'Állapot',
  'billing.invoices.download': 'Letöltés',
  'billing.invoices.st.paid': 'Kifizetve',
  'billing.invoices.st.open': 'Fizetésre vár',
  'billing.invoices.st.draft': 'Előkészítés alatt',
  'billing.invoices.st.void': 'Érvénytelenítve',
  'billing.invoices.st.uncollectible': 'Sikertelen terhelés',

  // ── Kártya-kapu (REQUIRE_VALID_CARD) ──
  'gate.title.missing': 'Add meg a kártyádat a kezdéshez',
  'gate.title.expired': 'Lejárt a kártyád',
  'gate.title.failed': 'A legutóbbi levonás nem sikerült',
  'gate.lead.missing': 'A portál ellenőrzött bankkártyával érhető el. Az első hónap ingyenes.',
  'gate.lead.expired': 'A márkához mentett kártya lejárt. Adj meg egy új kártyát, és a portál újra elérhető.',
  'gate.lead.failed': 'A legutóbbi levonás nem sikerült erről a kártyáról. Adj meg egy új kártyát, és a portál újra elérhető.',
  'gate.current': 'Mentett kártya: •••• {last4}',
  'gate.newCard': 'Új kártya megadása',
  'gate.memberTitle': 'A portál még nem érhető el',
  'gate.member': 'A márka tulajdonosa még nem adott meg kártyát. Szólj neki, hogy a portál elérhető legyen.',
  'gate.otherBrand': 'Másik márka',
  'gate.notValid.missing': 'A kártya ellenőrzése nem sikerült. Próbáld újra, vagy adj meg másik kártyát.',
  'gate.notValid.expired': 'A kártya lejárt. Adj meg másik kártyát.',
  'gate.notValid.failed': 'A bank nem fogadta el a kártyát. Adj meg másik kártyát.',
  'gate.checkFailed': 'Nem sikerült ellenőrizni a kártyát. Próbáld újra.',
  'gate.adminBanner': 'Nincs érvényes kártya',
  'gate.status.missing': 'a márka még nem adott meg kártyát (adminként beléptél)',
  'gate.status.expired': 'a márka kártyája lejárt (adminként beléptél)',
  'gate.status.failed': 'a legutóbbi levonás nem sikerült (adminként beléptél)',
  'gate.errorTitle': 'Nem sikerült betölteni a számlázást',
  'gate.errorBody': 'Próbáld újra pár másodperc múlva.',
  'gate.retry': 'Újra',
};

export default hu;
